var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5AxTandemSingleSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3245.84 800.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-220,.cls-221,.cls-222,.cls-223,.cls-224,.cls-225,.cls-226,.cls-227,.cls-228,.cls-229,.cls-230,.cls-231,.cls-232,.cls-233,.cls-234,.cls-235,.cls-236,.cls-237,.cls-238,.cls-239,.cls-240,.cls-241,.cls-242,.cls-243,.cls-244,.cls-245,.cls-246,.cls-247,.cls-248,.cls-249,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-258,.cls-259,.cls-260,.cls-261,.cls-262,.cls-263,.cls-264{stroke-width:0px;}.cls-2,.cls-260{fill:#414042;}.cls-3,.cls-6,.cls-134,.cls-265,.cls-237,.cls-238,.cls-239,.cls-241,.cls-250,.cls-251,.cls-252,.cls-253,.cls-254,.cls-255,.cls-256,.cls-257,.cls-260,.cls-263{mix-blend-mode:multiply;}.cls-3,.cls-230{fill:#f1f2f2;}.cls-4{fill:url(#New_Gradient_Swatch_4);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#linear-gradient-5);}.cls-266{filter:url(#luminosity-noclip-2);}.cls-267{filter:url(#luminosity-noclip-3);}.cls-268{filter:url(#luminosity-noclip-5);}.cls-7{fill:url(#New_Gradient_Swatch_3-3);}.cls-8{fill:url(#New_Gradient_Swatch_3-4);}.cls-9{fill:url(#New_Gradient_Swatch_3-8);}.cls-10{fill:url(#New_Gradient_Swatch_3-7);}.cls-11{fill:url(#New_Gradient_Swatch_3-6);}.cls-12{fill:url(#New_Gradient_Swatch_3-2);}.cls-13{fill:url(#New_Gradient_Swatch_3-5);}.cls-14{fill:url(#New_Gradient_Swatch_4-3);}.cls-15{fill:url(#New_Gradient_Swatch_4-2);}.cls-16{fill:url(#New_Gradient_Swatch_4-4);}.cls-17{fill:url(#New_Gradient_Swatch_4-5);}.cls-18{fill:#f7941d;}.cls-19{fill:url(#linear-gradient-179);}.cls-20{fill:url(#linear-gradient-177);}.cls-21{fill:url(#linear-gradient-176);}.cls-22{fill:url(#linear-gradient-178);}.cls-23{fill:url(#linear-gradient-120);}.cls-24{fill:url(#linear-gradient-125);}.cls-25{fill:url(#linear-gradient-124);}.cls-26{fill:url(#linear-gradient-126);}.cls-27{fill:url(#linear-gradient-180);}.cls-28{fill:url(#linear-gradient-184);}.cls-29{fill:url(#linear-gradient-185);}.cls-30{fill:url(#linear-gradient-186);}.cls-31{fill:url(#linear-gradient-181);}.cls-32{fill:url(#linear-gradient-182);}.cls-33{fill:url(#linear-gradient-183);}.cls-34{fill:url(#linear-gradient-138);}.cls-35{fill:url(#linear-gradient-139);}.cls-36{fill:url(#linear-gradient-134);}.cls-37{fill:url(#linear-gradient-131);}.cls-38{fill:url(#linear-gradient-136);}.cls-39{fill:url(#linear-gradient-132);}.cls-40{fill:url(#linear-gradient-135);}.cls-41{fill:url(#linear-gradient-130);}.cls-42{fill:url(#linear-gradient-133);}.cls-43{fill:url(#linear-gradient-137);}.cls-44{fill:url(#linear-gradient-195);}.cls-45{fill:url(#linear-gradient-194);}.cls-46{fill:url(#linear-gradient-189);}.cls-47{fill:url(#linear-gradient-190);}.cls-48{fill:url(#linear-gradient-100);}.cls-49{fill:url(#linear-gradient-101);}.cls-50{fill:url(#linear-gradient-192);}.cls-51{fill:url(#linear-gradient-191);}.cls-52{fill:url(#linear-gradient-193);}.cls-53{fill:url(#linear-gradient-123);}.cls-54{fill:url(#linear-gradient-129);}.cls-55{fill:url(#linear-gradient-121);}.cls-56{fill:url(#linear-gradient-122);}.cls-57{fill:url(#linear-gradient-109);}.cls-58{fill:url(#linear-gradient-108);}.cls-59{fill:url(#linear-gradient-106);}.cls-60{fill:url(#linear-gradient-107);}.cls-61{fill:url(#linear-gradient-102);}.cls-62{fill:url(#linear-gradient-104);}.cls-63{fill:url(#linear-gradient-103);}.cls-64{fill:url(#linear-gradient-105);}.cls-65{fill:url(#linear-gradient-117);}.cls-66{fill:url(#linear-gradient-118);}.cls-67{fill:url(#linear-gradient-111);}.cls-68{fill:url(#linear-gradient-112);}.cls-69{fill:url(#linear-gradient-127);}.cls-70{fill:url(#linear-gradient-128);}.cls-71{fill:url(#linear-gradient-110);}.cls-72{fill:url(#linear-gradient-113);}.cls-73{fill:url(#linear-gradient-114);}.cls-74{fill:url(#linear-gradient-115);}.cls-75{fill:url(#linear-gradient-116);}.cls-76{fill:url(#linear-gradient-119);}.cls-77{fill:url(#linear-gradient-173);}.cls-78{fill:url(#linear-gradient-170);}.cls-79{fill:url(#linear-gradient-175);}.cls-80{fill:url(#linear-gradient-174);}.cls-81{fill:url(#linear-gradient-172);}.cls-82{fill:url(#linear-gradient-144);}.cls-83{fill:url(#linear-gradient-145);}.cls-84{fill:url(#linear-gradient-149);}.cls-85{fill:url(#linear-gradient-148);}.cls-86{fill:url(#linear-gradient-171);}.cls-87{fill:url(#linear-gradient-146);}.cls-88{fill:url(#linear-gradient-143);}.cls-89{fill:url(#linear-gradient-169);}.cls-90{fill:url(#linear-gradient-140);}.cls-91{fill:url(#linear-gradient-141);}.cls-92{fill:url(#linear-gradient-147);}.cls-93{fill:url(#linear-gradient-166);}.cls-94{fill:url(#linear-gradient-142);}.cls-95{fill:url(#linear-gradient-168);}.cls-96{fill:url(#linear-gradient-164);}.cls-97{fill:url(#linear-gradient-161);}.cls-98{fill:url(#linear-gradient-163);}.cls-99{fill:url(#linear-gradient-158);}.cls-100{fill:url(#linear-gradient-160);}.cls-101{fill:url(#linear-gradient-159);}.cls-102{fill:url(#linear-gradient-167);}.cls-103{fill:url(#linear-gradient-162);}.cls-104{fill:url(#linear-gradient-165);}.cls-105{fill:url(#linear-gradient-154);}.cls-106{fill:url(#linear-gradient-152);}.cls-107{fill:url(#linear-gradient-157);}.cls-108{fill:url(#linear-gradient-155);}.cls-109{fill:url(#linear-gradient-151);}.cls-110{fill:url(#linear-gradient-153);}.cls-111{fill:url(#linear-gradient-150);}.cls-112{fill:url(#linear-gradient-156);}.cls-113{fill:url(#linear-gradient-209);}.cls-114{fill:url(#linear-gradient-219);}.cls-115{fill:url(#linear-gradient-213);}.cls-116{fill:url(#linear-gradient-211);}.cls-117{fill:url(#linear-gradient-214);}.cls-118{fill:url(#linear-gradient-217);}.cls-119{fill:url(#linear-gradient-212);}.cls-120{fill:url(#linear-gradient-218);}.cls-121{fill:url(#linear-gradient-208);}.cls-122{fill:url(#linear-gradient-207);}.cls-123{fill:url(#linear-gradient-205);}.cls-124{fill:url(#linear-gradient-201);}.cls-125{fill:url(#linear-gradient-203);}.cls-126{fill:url(#linear-gradient-204);}.cls-127{fill:url(#linear-gradient-206);}.cls-128{fill:url(#linear-gradient-200);}.cls-129{fill:url(#linear-gradient-202);}.cls-130{fill:url(#linear-gradient-210);}.cls-131{fill:url(#linear-gradient-216);}.cls-132{fill:url(#linear-gradient-220);}.cls-133{fill:url(#linear-gradient-221);}.cls-269{mask:url(#mask);}.cls-134,.cls-262{fill:#fff;}.cls-135,.cls-238{fill:#ed1c24;}.cls-136{fill:url(#linear-gradient);}.cls-270{filter:url(#luminosity-noclip);}.cls-137{fill:#ef4136;}.cls-138,.cls-237{fill:#6d6e71;}.cls-139{fill:#f15a29;}.cls-140{fill:url(#linear-gradient-38);}.cls-141{fill:url(#linear-gradient-33);}.cls-142{fill:url(#linear-gradient-29);}.cls-143{fill:url(#linear-gradient-32);}.cls-144{fill:url(#linear-gradient-30);}.cls-145{fill:url(#linear-gradient-31);}.cls-146{fill:url(#linear-gradient-36);}.cls-147{fill:url(#linear-gradient-39);}.cls-148{fill:url(#linear-gradient-34);}.cls-149{fill:url(#linear-gradient-37);}.cls-150{fill:url(#linear-gradient-35);}.cls-151{fill:url(#linear-gradient-28);}.cls-152{fill:url(#linear-gradient-25);}.cls-153{fill:url(#linear-gradient-11);}.cls-154{fill:url(#linear-gradient-12);}.cls-155{fill:url(#linear-gradient-13);}.cls-156{fill:url(#linear-gradient-10);}.cls-157{fill:url(#linear-gradient-17);}.cls-158{fill:url(#linear-gradient-16);}.cls-159{fill:url(#linear-gradient-19);}.cls-160{fill:url(#linear-gradient-15);}.cls-161{fill:url(#linear-gradient-23);}.cls-162{fill:url(#linear-gradient-21);}.cls-163{fill:url(#linear-gradient-18);}.cls-164{fill:url(#linear-gradient-14);}.cls-165{fill:url(#linear-gradient-22);}.cls-166{fill:url(#linear-gradient-20);}.cls-167{fill:url(#linear-gradient-27);}.cls-168{fill:url(#linear-gradient-24);}.cls-169{fill:url(#linear-gradient-26);}.cls-170{fill:url(#linear-gradient-45);}.cls-171{fill:url(#linear-gradient-46);}.cls-172{fill:url(#linear-gradient-44);}.cls-173{fill:url(#linear-gradient-48);}.cls-174{fill:url(#linear-gradient-49);}.cls-175{fill:url(#linear-gradient-47);}.cls-176{fill:url(#linear-gradient-42);}.cls-177{fill:url(#linear-gradient-43);}.cls-178{fill:url(#linear-gradient-40);}.cls-179{fill:url(#linear-gradient-41);}.cls-180{fill:url(#linear-gradient-59);}.cls-181{fill:url(#linear-gradient-57);}.cls-182{fill:url(#linear-gradient-58);}.cls-183{fill:url(#linear-gradient-55);}.cls-184{fill:url(#linear-gradient-56);}.cls-185{fill:url(#linear-gradient-53);}.cls-186{fill:url(#linear-gradient-51);}.cls-187{fill:url(#linear-gradient-52);}.cls-188{fill:url(#linear-gradient-50);}.cls-189{fill:url(#linear-gradient-54);}.cls-190{fill:url(#linear-gradient-60);}.cls-191{fill:url(#linear-gradient-61);}.cls-192{fill:url(#linear-gradient-62);}.cls-193{fill:url(#linear-gradient-65);}.cls-194{fill:url(#linear-gradient-79);}.cls-195{fill:url(#linear-gradient-78);}.cls-196{fill:url(#linear-gradient-77);}.cls-197{fill:url(#linear-gradient-75);}.cls-198{fill:url(#linear-gradient-76);}.cls-199{fill:url(#linear-gradient-74);}.cls-200{fill:url(#linear-gradient-67);}.cls-201{fill:url(#linear-gradient-68);}.cls-202{fill:url(#linear-gradient-66);}.cls-203{fill:url(#linear-gradient-63);}.cls-204{fill:url(#linear-gradient-69);}.cls-205{fill:url(#linear-gradient-64);}.cls-206{fill:url(#linear-gradient-71);}.cls-207{fill:url(#linear-gradient-72);}.cls-208{fill:url(#linear-gradient-70);}.cls-209{fill:url(#linear-gradient-73);}.cls-210{fill:url(#linear-gradient-84);}.cls-211{fill:url(#linear-gradient-85);}.cls-212{fill:url(#linear-gradient-82);}.cls-213{fill:url(#linear-gradient-83);}.cls-214{fill:url(#linear-gradient-89);}.cls-215{fill:url(#linear-gradient-88);}.cls-216{fill:url(#linear-gradient-86);}.cls-217{fill:url(#linear-gradient-87);}.cls-218{fill:url(#linear-gradient-80);}.cls-219{fill:url(#linear-gradient-81);}.cls-220{fill:url(#linear-gradient-98);}.cls-221{fill:url(#linear-gradient-91);}.cls-222{fill:url(#linear-gradient-92);}.cls-223{fill:url(#linear-gradient-93);}.cls-224{fill:url(#linear-gradient-90);}.cls-225{fill:url(#linear-gradient-96);}.cls-226{fill:url(#linear-gradient-97);}.cls-227{fill:url(#linear-gradient-94);}.cls-228{fill:url(#linear-gradient-95);}.cls-229{fill:url(#linear-gradient-99);}.cls-231{fill:#58595b;}.cls-232,.cls-239{fill:#bcbec0;}.cls-233{fill:#808285;}.cls-234,.cls-242{fill:#000;}.cls-235,.cls-241{fill:#a7a9ac;}.cls-236{fill:url(#New_Gradient_Swatch_11_cop);}.cls-240{fill:#be1e2d;}.cls-242{opacity:.5;}.cls-243{fill:url(#linear-gradient-4);}.cls-244{fill:url(#linear-gradient-2);}.cls-245{fill:url(#linear-gradient-3);}.cls-246{fill:url(#linear-gradient-8);}.cls-247{fill:url(#linear-gradient-9);}.cls-248{fill:url(#linear-gradient-7);}.cls-249{fill:url(#linear-gradient-6);}.cls-250{fill:url(#linear-gradient-215);}.cls-251{fill:url(#linear-gradient-197);}.cls-252{fill:url(#linear-gradient-196);}.cls-253{fill:url(#linear-gradient-199);}.cls-254{fill:url(#linear-gradient-198);}.cls-255{fill:url(#linear-gradient-187);}.cls-256{fill:url(#linear-gradient-188);}.cls-257,.cls-259{fill:#c49a6c;}.cls-271{isolation:isolate;}.cls-258{fill:#e6e7e8;}.cls-261{fill:#d1d3d4;}.cls-263{fill:#939598;}.cls-272{mask:url(#mask-3);}.cls-273{mask:url(#mask-2);}.cls-274{mask:url(#mask-5);}.cls-275{mask:url(#mask-4);}.cls-276{mask:url(#mask-1);}.cls-264{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 712.8,
    width: 1694.64,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 712.8,
    width: 1694.64,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1695,
    height: 88,
    transform: "translate(-.31 712.51)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 1927.2,
    y: 712.8,
    width: 1318.65,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 1927.2,
    y: 712.8,
    width: 1318.65,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-266"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1320,
    height: 88,
    transform: "translate(1926.69 712.51)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1647,
    y1: 577.92,
    x2: 1755.34,
    y2: 577.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1711.04,
    y1: 588,
    x2: 1755.34,
    y2: 588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#322f31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 567.85,
    y2: 567.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1765.92,
    y1: 577.92,
    x2: 2006.28,
    y2: 577.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6c6e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1765.92,
    y1: 577.86,
    x2: 2005.91,
    y2: 577.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -4968.14,
    y1: -1381.17,
    x2: -4968.14,
    y2: -1396.62,
    gradientTransform: "translate(6618.4 1984.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#434345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4d4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5c5d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#737376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8f9194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1650.51,
    y1: 543.33,
    x2: 1693.4,
    y2: 543.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#464547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#939495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#aeafb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c1c3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#cdcfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1648.22,
    y1: 597.44,
    x2: 1648.22,
    y2: 594.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 594.07,
    y2: 590.75,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1648.98,
    y1: 567.03,
    x2: 1648.98,
    y2: 542.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 592.1,
    y2: 587.77,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1613.68,
    y1: 577.1,
    x2: 1658.71,
    y2: 577.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1663.2,
    y1: 579.8,
    x2: 1683.75,
    y2: 579.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#67686a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9d9e9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c4c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2002.27,
    y1: 573.03,
    x2: 2307.3,
    y2: 573.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#302f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2033.58,
    y1: 540.83,
    x2: 2033.58,
    y2: 510.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3f3e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#393739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2e2c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2008.34,
    x2: 2008.34,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2041.56,
    x2: 2041.56,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2268.39,
    x2: 2268.39,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2276.36,
    x2: 2276.36,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2301.45,
    x2: 2301.45,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 2180.07,
    y1: 713.67,
    x2: 2180.07,
    y2: 526.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 2180.07,
    y1: 543.79,
    x2: 2180.07,
    y2: 702.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2180.07,
    y1: 678.45,
    x2: 2180.07,
    y2: 563.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2180.04,
    y1: 569.83,
    x2: 2180.04,
    y2: 670.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#68696b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#929495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2180.07,
    y1: 638.92,
    x2: 2180.07,
    y2: 601.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2180.07,
    y1: 634.04,
    x2: 2180.07,
    y2: 607.41,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 3295.12,
    y1: 4791.02,
    x2: 3295.12,
    y2: 4612.33,
    gradientTransform: "translate(-2043.97 3864.49) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 3317.03,
    y1: 4609.34,
    x2: 3317.03,
    y2: 4793.82,
    gradientTransform: "translate(6066.26 5340.65) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 4609.34,
    y2: 4793.82,
    gradientTransform: "translate(6063.69 5338.08) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 4609.36,
    y2: 4793.82,
    gradientTransform: "translate(6060.51 5334.9) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6056.68 5331.07) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6052.18 5326.57) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6047.14 5321.53) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6041.55 5315.95) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6035.5 5309.9) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6028.83 5303.23) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6021.9 5296.3) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6014.47 5288.86) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(6006.82 5281.21) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(5998.8 5273.2) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(5990.69 5265.08) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(5982.46 5256.85) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-751.09 -4062.45)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    y1: 4609.35,
    y2: 4793.83,
    gradientTransform: "translate(-748.51 -4065.03)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-745.33 -4068.21)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-741.5 -4072.04)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-737.01 -4076.53)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-731.96 -4081.58)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-726.38 -4087.16)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-720.33 -4093.21)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-713.66 -4099.88)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-706.73 -4106.81)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-699.3 -4114.24)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-691.64 -4121.9)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-683.63 -4129.91)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-675.51 -4138.03)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    y1: 4609.35,
    y2: 4793.82,
    gradientTransform: "translate(-667.29 -4146.25)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 3317.03,
    y1: 4609.35,
    x2: 3317.03,
    y2: 4793.82,
    gradientTransform: "translate(-659.45 -4154.09)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 3273.2,
    x2: 3273.2,
    gradientTransform: "translate(6022.43 5384.49) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 3273.2,
    y1: 4609.34,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(6019.85 5381.91) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 3273.2,
    y1: 4609.36,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(6016.67 5378.73) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(6012.84 5374.91) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(6008.35 5370.41) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(6003.3 5365.37) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5997.72 5359.78) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5991.67 5353.73) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5985 5347.06) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5978.07 5340.13) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5970.64 5332.7) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5962.98 5325.05) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5954.97 5317.03) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5946.85 5308.91) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(5938.63 5300.69) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-707.25 -4018.62)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.83,
    gradientTransform: "translate(-704.68 -4021.19)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-701.5 -4024.37)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-697.67 -4028.2)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-693.17 -4032.7)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-688.13 -4037.74)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-682.54 -4043.33)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-676.49 -4049.38)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-669.82 -4056.05)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-662.9 -4062.97)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-655.46 -4070.41)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-647.81 -4078.06)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-639.79 -4086.08)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-631.68 -4094.19)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-623.45 -4102.42)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 3273.2,
    y1: 4609.35,
    x2: 3273.2,
    y2: 4793.82,
    gradientTransform: "translate(-615.61 -4110.26)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 3295.12,
    y1: 4610.85,
    x2: 3295.12,
    y2: 4794.32,
    gradientTransform: "translate(-637.53 -4132.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 3074.97,
    y1: 604.79,
    x2: 3074.97,
    y2: 541.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#353436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#171617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 262.38,
    x2: 262.38,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 262.38,
    x2: 262.38,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 262.38,
    y1: 570.62,
    x2: 262.38,
    y2: 670.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 262.38,
    y1: 650.34,
    x2: 262.38,
    y2: 590.15,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 262.38,
    x2: 262.38,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 262.38,
    y1: 604.09,
    x2: 262.38,
    y2: 638.57,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 262.38,
    y1: 634.15,
    x2: 262.38,
    y2: 607.3,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 3220.72,
    y1: 515.13,
    x2: 3220.72,
    y2: 561.99,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 3231.58,
    y1: 600.45,
    x2: 3231.58,
    y2: 617.46,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 3220.11,
    y1: 480.76,
    x2: 3220.11,
    y2: 634.21,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 762.54,
    y1: 3111.7,
    x2: 762.54,
    y2: 3130.14,
    gradientTransform: "translate(4004.21 3670.94) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 3241.67,
    y1: 517.67,
    x2: 3241.67,
    y2: 537.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 3074.97,
    x2: 3074.97,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 3074.97,
    x2: 3074.97,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 3074.97,
    x2: 3074.97,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 3074.94,
    x2: 3074.94,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 3074.97,
    x2: 3074.97,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 3074.97,
    y1: 634.04,
    x2: 3074.97,
    y2: 607.41,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1148.17,
    y1: 546.43,
    x2: 1148.17,
    y2: 552.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1148.17,
    y1: 552.3,
    x2: 1148.17,
    y2: 558,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    y1: 558.16,
    y2: 563.61,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1148.17,
    y1: 563.92,
    x2: 1148.17,
    y2: 569.25,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    y1: 569.35,
    y2: 575.12,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1148.17,
    y1: 575.33,
    x2: 1148.17,
    y2: 581.32,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    y1: 581.63,
    y2: 586.63,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1148.17,
    y1: 586.85,
    x2: 1148.17,
    y2: 592.06,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1148.17,
    y1: 593.04,
    x2: 1148.17,
    y2: 598.15,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    y1: 598.91,
    y2: 604.02,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1148.17,
    y1: 604.56,
    x2: 1148.17,
    y2: 610.45,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1148.17,
    y1: 610.86,
    x2: 1148.17,
    y2: 615.75,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1128.23,
    y1: 546.38,
    x2: 1128.23,
    y2: 622.59,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1168.1,
    y1: 546.38,
    x2: 1168.1,
    y2: 622.59,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 1029.67,
    x2: 1029.67,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 1029.67,
    x2: 1029.67,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1029.67,
    x2: 1029.67,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1029.64,
    x2: 1029.64,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1029.67,
    x2: 1029.67,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1029.67,
    y1: 634.04,
    x2: 1029.67,
    y2: 607.41,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 1266.37,
    x2: 1266.37,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 1266.37,
    x2: 1266.37,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1266.37,
    x2: 1266.37,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1266.33,
    x2: 1266.33,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1266.37,
    x2: 1266.37,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1266.37,
    y1: 634.04,
    x2: 1266.37,
    y2: 607.41,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 4253.19,
    y1: 4958.34,
    x2: 4253.19,
    y2: 4779.65,
    gradientTransform: "translate(-3373.96 4858.09) rotate(-90)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 4274.68,
    y1: 4776.66,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5861.24 5543.93) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5858.66 5541.35) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 4274.68,
    y1: 4776.68,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5855.48 5538.17) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5851.65 5534.34) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5847.15 5529.84) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5842.11 5524.8) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5836.53 5519.22) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5830.48 5513.17) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5823.81 5506.5) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5816.88 5499.57) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5809.45 5492.13) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5801.79 5484.48) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5793.78 5476.47) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5785.66 5468.35) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(5777.44 5460.13) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2871.41 -4193.82)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2868.83 -4196.4)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2865.65 -4199.58)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.15,
    gradientTransform: "translate(-2861.82 -4203.41)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2857.32 -4207.91)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.15,
    gradientTransform: "translate(-2852.28 -4212.95)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.15,
    gradientTransform: "translate(-2846.7 -4218.53)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2840.65 -4224.58)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2833.98 -4231.25)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2827.05 -4238.18)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.15,
    gradientTransform: "translate(-2819.61 -4245.62)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.15,
    gradientTransform: "translate(-2811.96 -4253.27)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2803.95 -4261.28)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2795.83 -4269.4)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2787.61 -4277.62)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 4274.68,
    y1: 4776.67,
    x2: 4274.68,
    y2: 4961.14,
    gradientTransform: "translate(-2779.76 -4285.47)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 4231.71,
    y1: 4776.66,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5818.27 5586.89) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5815.69 5584.32) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 4231.71,
    y1: 4776.68,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5812.51 5581.14) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5808.69 5577.31) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5804.19 5572.81) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5799.14 5567.77) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5793.56 5562.18) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5787.51 5556.13) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5780.84 5549.46) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5773.91 5542.53) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5766.48 5535.1) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5758.82 5527.45) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5750.81 5519.43) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5742.69 5511.31) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(5734.47 5503.09) rotate(-180)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2828.44 -4150.86)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2825.86 -4153.43)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2822.68 -4156.61)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.15,
    gradientTransform: "translate(-2818.85 -4160.44)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2814.35 -4164.94)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.15,
    gradientTransform: "translate(-2809.31 -4169.98)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.15,
    gradientTransform: "translate(-2803.73 -4175.56)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2797.68 -4181.61)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2791.01 -4188.29)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2784.08 -4195.21)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.15,
    gradientTransform: "translate(-2776.65 -4202.65)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.15,
    gradientTransform: "translate(-2768.99 -4210.3)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2760.98 -4218.32)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2752.86 -4226.43)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2744.64 -4234.66)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 4231.71,
    y1: 4776.67,
    x2: 4231.71,
    y2: 4961.14,
    gradientTransform: "translate(-2736.79 -4242.5)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 4253.19,
    y1: 4778.17,
    x2: 4253.19,
    y2: 4961.64,
    gradientTransform: "translate(-2758.28 -4263.98)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 157.57,
    y1: 396.46,
    x2: 157.57,
    y2: 255.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 304.78,
    y1: 396.46,
    x2: 304.78,
    y2: 255.65,
    xlinkHref: "#linear-gradient-187"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 415.35,
    y1: 565.29,
    x2: 415.35,
    y2: 483.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 455.36,
    y1: 5221.82,
    x2: 455.36,
    y2: 5140.25,
    gradientTransform: "translate(887.01 5731.06) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 315.17,
    y1: 5274.78,
    x2: 315.17,
    y2: 5342.62,
    gradientTransform: "translate(-1674.12 5418.23) rotate(-153.27)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 315.17,
    y1: 5334.83,
    x2: 315.17,
    y2: 5281.76,
    gradientTransform: "translate(-1752.45 5383.7) rotate(-152.35)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 315.17,
    y1: 5287.51,
    x2: 315.17,
    y2: 5329.49,
    gradientTransform: "translate(-4804.02 1464.84) rotate(-96.67)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 315.17,
    y1: 5324.67,
    x2: 315.17,
    y2: 5291.82,
    gradientTransform: "translate(-2157.12 5180.24) rotate(-147.47)",
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 396.27,
    y1: 302.46,
    x2: 379.88,
    y2: 302.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 3172.34,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 3172.34,
    y: -9779.51,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 3172.34,
    y: -9779.51,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 3181.35,
    y1: 541.26,
    x2: 3181.35,
    y2: 486.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 3172.34,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-272"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "3179.5 541.26 3172.34 541.26 3172.34 486.41 3190.36 486.41 3179.5 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 3181.35,
    y1: 541.26,
    x2: 3181.35,
    y2: 486.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#a7a5a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#767474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 2959.59,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 2959.59,
    y: -9779.51,
    width: 18.02,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 2959.59,
    y: -9779.51,
    width: 18.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 595.96,
    x2: 595.96,
    gradientTransform: "translate(3564.56) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-196"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 2959.59,
    y: 486.41,
    width: 18.02,
    height: 54.85,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-268"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-274"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "2970.45 541.26 2977.61 541.26 2977.61 486.41 2959.59 486.41 2970.45 541.26"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 595.96,
    x2: 595.96,
    gradientTransform: "translate(3564.56) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-197"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 1055.46,
    y1: 1.28,
    x2: 1055.46,
    y2: 480.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 2634.27,
    y1: 1.28,
    x2: 2634.27,
    y2: 480.92,
    xlinkHref: "#linear-gradient-200"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 198.5,
    y1: 213.83,
    x2: 198.5,
    y2: 520.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 110.22,
    y1: 560.37,
    x2: 110.22,
    y2: 525.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 96.73,
    y1: 619.73,
    x2: 96.73,
    y2: 627.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 32.38,
    y1: 520.68,
    x2: 32.38,
    y2: 628.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 477.37,
    y1: 514.53,
    x2: 477.37,
    y2: 495.02,
    gradientTransform: "translate(359.49 1009.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 452.34,
    y1: 494.85,
    x2: 452.34,
    y2: 515.4,
    gradientTransform: "translate(409.55 1009.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: -121.25,
    y1: 514.53,
    x2: -121.25,
    y2: 495.02,
    gradientTransform: "translate(1556.73 1009.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-205"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: -146.28,
    y1: 494.85,
    x2: -146.28,
    y2: 515.4,
    gradientTransform: "translate(1606.79 1009.1) scale(1 -1)",
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: -726.23,
    y1: 492.02,
    x2: -726.23,
    y2: 477.08,
    gradientTransform: "translate(2766.69 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-205"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: -745.41,
    y1: 476.94,
    x2: -745.41,
    y2: 492.69,
    gradientTransform: "translate(2805.04 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: -1310.46,
    y1: 492.02,
    x2: -1310.46,
    y2: 477.08,
    gradientTransform: "translate(3935.14 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-205"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: -1329.63,
    y1: 476.94,
    x2: -1329.63,
    y2: 492.69,
    gradientTransform: "translate(3973.49 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: -1894.68,
    y1: 492.02,
    x2: -1894.68,
    y2: 477.08,
    gradientTransform: "translate(5103.6 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-205"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: -1913.86,
    y1: 476.94,
    x2: -1913.86,
    y2: 492.69,
    gradientTransform: "translate(5141.94 968.75) scale(1 -1)",
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 228.59,
    y1: 432.06,
    x2: 228.59,
    y2: 415.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 209.05,
    y1: 420.47,
    x2: 209.05,
    y2: 427.61,
    xlinkHref: "#linear-gradient-204"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 246.63,
    y1: 420.47,
    x2: 246.63,
    y2: 427.61,
    xlinkHref: "#linear-gradient-204"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 227.84,
    y1: 421.43,
    x2: 227.84,
    y2: 426.56,
    xlinkHref: "#linear-gradient-187"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 84.75,
    y1: 500.52,
    x2: 84.75,
    y2: 511.71,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 7.62,
    y1: 356.93,
    x2: 18.41,
    y2: 388.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 12.87,
    y1: 261.24,
    x2: 12.87,
    y2: 352.51,
    xlinkHref: "#linear-gradient-220"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-269"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-265",
    width: 1695,
    height: 88,
    transform: "translate(-.31 712.51)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-265",
    width: 1320,
    height: 88,
    transform: "translate(1926.69 712.51)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M386.51,467.43v-22.48c0-13.6-11.03-24.63-24.64-24.63H60.34v167.59h61.44c14.98,0,29.61,3,42.31,8.66,16.52,7.38,35.51,11.27,54.92,11.27h99.68c8.66,0,17.34-.83,25.76-2.37,7.53,6.08,15.39,10.05,23.09,10.05h150.06v4.66c0,2.43,1.97,4.4,4.4,4.4h8.79v6.65h33.77v-6.65h41.67v6.65h33.78v-6.65h41.67v6.65h33.77v-6.65h8.79c2.43,0,4.4-1.97,4.4-4.4v-7.03l284.03,24.6,1.14-13.13-285.16-24.7v-6.44h49.34v7.77h181.17v-7.77h665.54v-126.04H386.51ZM318.69,588.54h-99.68c-14.98,0-29.61-3-42.31-8.67-5.98-2.67-12.3-4.87-18.83-6.61h158.75c3.36,4.97,7.05,10.06,10.98,14.91-2.96.24-5.94.36-8.91.36ZM342.15,585.99c-3.45-3.87-6.88-8.18-10.22-12.73h50.23c-3.18.84-6.31,1.77-9.35,2.83l-19.12,6.66c-3.72,1.3-7.59,2.36-11.55,3.23ZM517.6,603.02h-150.06c-2.12,0-4.37-.59-6.7-1.63,1.08-.34,2.17-.67,3.23-1.04l19.12-6.67c10.84-3.78,22.95-5.78,35.02-5.78h25.32l-.05.54,74.12,6.42v8.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 1651.23,
    y: 555.99,
    width: 4.33,
    height: 32.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1887.41,579.92h-83.13c-14.42,0-25.79-9.14-40.18-20.7-25.51-20.51-60.45-48.59-139.14-48.59v-4c80.09,0,115.66,28.59,141.64,49.47,13.78,11.07,24.66,19.82,37.68,19.82h83.13c20.8,0,34.75-3.95,42.64-12.09,9.74-10.05,9.28-25.19,8.79-41.21-.69-22.34-1.4-45.44,27.36-53.99,13.29-3.95,22.27,2.58,30.19,8.34,5.89,4.29,11.46,8.34,18.41,8.34h35.15v4h-35.15c-8.25,0-14.61-4.63-20.76-9.1-7.87-5.73-15.3-11.13-26.7-7.75-25.8,7.67-25.17,28.25-24.5,50.04.5,16.15,1.01,32.86-9.91,44.12-8.68,8.95-23.56,13.3-45.51,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1901.84,580.79h-97.56c-14.33,0-25.67-8.17-40.03-18.52-25.54-18.4-60.51-43.61-139.28-43.61v-3.78c80,0,115.54,25.62,141.49,44.32,13.81,9.95,24.71,17.81,37.82,17.81h97.56c21.47,0,34.16-3.15,38.79-9.64,4.62-6.48,1.3-16.14-2.55-27.33-6.7-19.46-15.04-43.69,21.43-58.26,14.41-5.76,23.27-2.3,32.64,1.36,6.5,2.54,13.22,5.17,22.64,5.17h35.15v3.78h-35.15c-10.13,0-17.51-2.88-24.02-5.43-9.03-3.53-16.83-6.58-29.86-1.37-33.12,13.23-26.07,33.71-19.25,53.51,4.02,11.67,7.81,22.68,2.05,30.75-5.46,7.66-18.77,11.22-41.87,11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2029.19,589.8h-319.4v-23.76h319.4c6.56,0,11.88,5.32,11.88,11.88h0c0,6.56-5.32,11.88-11.88,11.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1729.93,599.91h-22.58c-10.81,0-14.63-9.85-14.63-21.99h0c0-12.15,3.82-21.99,14.63-21.99h22.58c10.81,0,42.16,9.85,42.16,21.99h0c0,12.15-31.34,21.99-42.16,21.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1755.34,581.93h-104.33c-2.21,0-4-1.79-4-4h0c0-2.21,1.79-4,4-4h104.33v8.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 1711.04,
    y: 586.19,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 1711.04,
    y: 566.04,
    width: 44.3,
    height: 3.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1736.66,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1736.66,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1746.41,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 1746.41,
    cy: 577.92,
    r: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1697.41,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1697.41,575.76c1.19,0,2.16.97,2.16,2.16s-.97,2.16-2.16,2.16-2.16-.97-2.16-2.16.97-2.16,2.16-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1707.15,575.15c1.53,0,2.77,1.24,2.77,2.77s-1.24,2.77-2.77,2.77-2.77-1.24-2.77-2.77,1.24-2.77,2.77-2.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 1707.15,
    cy: 577.92,
    r: 2.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1711.04,
    y: 555.93,
    width: 7.99,
    height: 43.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1842.25,560.88c0-3.66-2.96-6.62-6.62-6.62s-6.62,2.96-6.62,6.62v21.31h13.24v-21.31ZM1832.63,560.26c0-1.65,1.34-3,3-3s3,1.34,3,3-1.34,3-3,3-3-1.34-3-3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1765.92,
    y: 566.04,
    width: 240.36,
    height: 23.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 1765.92,
    y: 569.79,
    width: 240.36,
    height: 16.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1993.52,518.83l-156.87,42.53c-.74.2-1.51-.24-1.71-.98h0c-.2-.74.24-1.51.98-1.71l156.87-42.53c.74-.2,1.51.24,1.71.98h0c.2.74-.24,1.51-.98,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1872.93,556.11h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1872.22,554.46h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1871.88,552.23h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1875.28,555.48h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1874.56,553.82h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1874.22,551.59h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1877.62,554.84h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1876.9,553.19h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1876.56,550.96h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1879.96,554.21h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1879.24,552.55h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1878.9,550.32h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1882.3,553.58h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1881.58,551.92h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1881.24,549.69h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1884.64,552.94h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1883.92,551.28h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1883.58,549.05h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1886.98,552.31h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1886.26,550.65h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1885.93,548.42h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1889.32,551.67h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1888.6,550.01h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1888.27,547.78h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1891.66,551.04h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1890.94,549.38h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1890.61,547.15h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1894,550.4h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1893.28,548.74h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1892.95,546.51h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1896.34,549.77h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1895.62,548.11h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1895.29,545.88h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1898.68,549.13h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1897.96,547.47h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1897.63,545.25h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1901.02,548.5h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1900.31,546.84h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1899.97,544.61h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1903.37,547.86h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1902.65,546.21h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1902.31,543.98h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1905.71,547.23h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1904.99,545.57h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1904.65,543.34h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1908.05,546.59h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1907.33,544.94h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1906.99,542.71h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1910.39,545.96h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1909.67,544.3h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1909.33,542.07h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1912.73,545.33h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1912.01,543.67h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1911.67,541.44h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1915.07,544.69h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1914.35,543.03h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1914.02,540.8h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1917.41,544.06h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1916.69,542.4h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1916.36,540.17h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1919.75,543.42h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1919.03,541.76h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1918.7,539.53h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1922.09,542.79h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1921.37,541.13h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1921.04,538.9h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1924.43,542.15h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1923.71,540.49h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1923.38,538.26h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1926.77,541.52h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1926.05,539.86h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1925.72,537.63h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1929.11,540.88h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1928.4,539.22h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1928.06,537h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1931.45,540.25h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1930.74,538.59h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1930.4,536.36h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1933.8,539.61h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1933.08,537.96h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1932.74,535.73h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1936.14,538.98h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1935.42,537.32h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1935.08,535.09h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1938.48,538.35h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1937.76,536.69h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1937.42,534.46h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1940.82,537.71h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1940.1,536.05h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1939.76,533.82h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1943.16,537.08h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1942.44,535.42h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1942.1,533.19h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1945.5,536.44h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1944.78,534.78h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1944.45,532.55h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1947.84,535.81h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1947.12,534.15h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1946.79,531.92h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1950.18,535.17h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1949.46,533.51h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1949.13,531.28h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1952.52,534.54h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1951.8,532.88h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1951.47,530.65h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1954.86,533.9h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1954.14,532.24h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1953.81,530.01h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1957.2,533.27h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1956.49,531.61h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1956.15,529.38h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1959.54,532.63h0c-.65.18-1.31-.21-1.49-.85l-2.42-8.92c-.18-.65.21-1.31.85-1.49h0c.65-.18,1.31.21,1.49.85l2.42,8.92c.18.65-.21,1.31-.85,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1958.83,530.98h0c-.51.14-1.03-.16-1.17-.67l-1.9-7.01c-.14-.51.16-1.03.67-1.17h0c.51-.14,1.03.16,1.17.67l1.9,7.01c.14.51-.16,1.03-.67,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1958.49,528.75h0c-.36.1-.74-.12-.84-.48l-1.36-5.02c-.1-.36.12-.74.48-.84h0c.36-.1.74.12.84.48l1.36,5.02c.1.36-.12.74-.48.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 1765.92,
    y: 569.65,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1894.63,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1931.19,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1967.74,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1784.98,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1821.53,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1858.08,
    y: 569.65,
    width: 19.12,
    height: 16.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1765.92,
    y: 569.65,
    width: 239.99,
    height: 16.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M1646.49,587.9h7.54c1.52,0,2.75,1.23,2.75,2.75v12.99h-13.04v-12.99c0-1.52,1.23-2.75,2.75-2.75Z",
    transform: "translate(3300.52 1191.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M1661.57,553.87h-9.98c-.74,0-1.33-.6-1.33-1.33s.6-1.33,1.33-1.33h9.98c2.92,0,5.73-.89,8.12-2.57l22.18-15.61c.6-.43,1.43-.28,1.86.32.42.6.28,1.43-.32,1.86l-22.18,15.61c-2.84,2-6.18,3.06-9.65,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M1659.09,597.46h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M1659.09,594.09h-21.75c-.93,0-1.69-.76-1.69-1.69h0c0-.93.76-1.69,1.69-1.69h21.75c.93,0,1.69.76,1.69,1.69h0c0,.93-.76,1.69-1.69,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1643.01,542.25h11.94c2.41,0,4.36,1.95,4.36,4.36v20.57h-20.65v-20.57c0-2.41,1.95-4.36,4.36-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1657.1,592.13h-17.76c-1.22,0-2.21-.99-2.21-2.21h0c0-1.22.99-2.21,2.21-2.21h17.76c1.22,0,2.21.99,2.21,2.21h0c0,1.22-.99,2.21-2.21,2.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "1646.32 586.32 1646.32 567.5 1659.3 567.5 1659.3 564.56 1613.42 564.56 1613.42 589.63 1657.08 589.63 1657.08 586.32 1646.32 586.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1682.59,595.15l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02h0c0,1.22.75,2.31,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1682.59,595.15l-2.82-1.1c-1.53-.6-2.53-2.07-2.53-3.71v-20.64c0-1.91,1.17-3.62,2.95-4.31l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-.62.24-1.26.45-1.89.64v25.24l17.87,6.98c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M1693.72,533.36c-.42-.6-1.25-.75-1.86-.32l-22.18,15.61c-2.39,1.68-5.2,2.57-8.12,2.57h-2.27v-4.6c0-2.41-1.95-4.36-4.36-4.36h-11.94c-2.41,0-4.36,1.95-4.36,4.36v17.96h-25.23v25.06h23.76c-.01.1-.06.19-.06.29,0,.28.06.55.16.8-.9.03-1.63.76-1.63,1.68s.76,1.69,1.69,1.69c-.93,0-1.69.76-1.69,1.69s.76,1.69,1.69,1.69h6.4v3.43c0,1.52,1.23,2.75,2.75,2.75h7.54c1.52,0,2.75-1.23,2.75-2.75v-3.43h2.31c.93,0,1.69-.76,1.69-1.69s-.76-1.69-1.69-1.69c.93,0,1.69-.76,1.69-1.69s-.73-1.65-1.63-1.68c.1-.25.16-.52.16-.8,0-1.22-.99-2.21-2.21-2.21h-.01v-1.4h-10.76v-18.81h12.98v-13.63h2.27c3.47,0,6.81-1.06,9.65-3.06l22.18-15.61c.6-.42.75-1.25.32-1.86ZM1677.44,568.32c.41-1.32,1.4-2.41,2.74-2.93l2.41-.94c1.16-.45,1.73-1.76,1.28-2.92-.45-1.16-1.76-1.73-2.92-1.28l-15.98,6.24c-2.81,1.1-5.8,1.66-8.82,1.66h-8.87v3.25h10.14c1.25,0,2.26,1.01,2.26,2.26v6.84c0,1.25-1.01,2.26-2.26,2.26h-10.14v3.25h9.38c1.67,0,3.02,1.35,3.02,3.02,0,1.22.75,2.31,1.88,2.76l19.39,7.57c.27.1.55.15.82.15.9,0,1.75-.54,2.1-1.43.45-1.16-.12-2.46-1.28-2.92l-2.82-1.1c-.16-.06-.29-.17-.44-.25-1.26-.69-2.09-1.99-2.09-3.46v-20.64c0-.48.07-.94.21-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1624.7,592.93h0c-1.1,0-2-.89-2-2v-27.67c0-1.1.89-2,2-2h0c1.1,0,2,.89,2,2v27.67c0,1.1-.89,2-2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2020.12,
    y: 592.71,
    width: 39.48,
    height: 6.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M2010.08,583.56c-2.44,2.61-2.3,6.72.31,9.16l8.71,8.13c2.61,2.44,6.72,2.3,9.16-.31,2.44-2.61,2.3-6.72-.31-9.16l-8.71-8.13c-2.61-2.44-6.72-2.3-9.16.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M2027.7,600.02h0c-2.15,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.15-2.43-5.77-.28-8.08h0c2.15-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.15,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2017.18,585.67c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16-1.33-1.25-1.41-3.34-.16-4.67,1.25-1.33,3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2016.68,586.2c1.04.97,1.1,2.6.13,3.64-.97,1.04-2.6,1.1-3.64.13-1.04-.97-1.1-2.6-.13-3.64.97-1.04,2.6-1.1,3.64-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2025.67,593.6c1.33,1.25,1.41,3.34.16,4.67-1.25,1.33-3.34,1.41-4.67.16-1.33-1.25-1.41-3.34-.16-4.67,1.25-1.33,3.34-1.41,4.67-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2025.18,594.13c1.04.97,1.1,2.6.12,3.64-.97,1.04-2.6,1.1-3.64.13-1.04-.97-1.1-2.6-.12-3.64.97-1.04,2.6-1.1,3.64-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M2027.7,600.02h0c-2.15,2.31-5.77,2.43-8.08.28l-8.71-8.13c-2.31-2.15-2.43-5.77-.28-8.08h0c2.15-2.31,5.77-2.43,8.08-.28l8.71,8.13c2.31,2.15,2.43,5.77.28,8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2304.88,591.07l-5.05-13.55c-2.32-6.23-7.8-8.64-12.24-5.39h0c-4.44,3.25-6.17,10.93-3.85,17.16l2.97,7.98h-98.58v-.59h-16.12v.59h-98.58l2.97-7.98c2.32-6.23.59-13.91-3.85-17.15h0c-4.44-3.25-9.92-.83-12.24,5.4l-5.04,13.55c-2.32,6.23-.59,13.9,3.85,17.15h0c4.01,2.93,8.83,1.22,11.45-3.7h22.85v3.63h8.98v3.63h14.23v3.63h15.72v3.63h20.23v3.63h19.44v2.37h16.12v-2.37h19.44v-3.63h20.23v-3.63h15.73v-3.63h14.22v-3.63h8.98v-3.63h22.85c2.61,4.92,7.44,6.63,11.45,3.7h0c4.44-3.25,6.17-10.93,3.85-17.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2064.69,
    y: 473.89,
    width: 215.96,
    height: 75.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M2002.27,541.26v5.12l20.43,18.32v17.28l23.52,22.8h12.88l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h209.96l24.45-21.05v-29.01h-305.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M2006.05,538.26v5.12l20.43,18.32v17.28l23.52,22.8h6.42l.25-1.73c.97-6.74,6.74-11.74,13.55-11.74h208.68l24.45-21.05v-29.01h-297.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2037.54,572.99c2.73,0,4.94,2.21,4.94,4.94s-2.21,4.94-4.94,4.94-4.94-2.21-4.94-4.94,2.21-4.94,4.94-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2037.54,574.07c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85-3.85-1.72-3.85-3.85,1.72-3.85,3.85-3.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-233",
    cx: 2054.91,
    cy: 577.92,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 2054.91,
    cy: 577.92,
    r: 3.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1994.93,510.45c-3.66,0-6.62,2.96-6.62,6.62s2.96,6.62,6.62,6.62h21.31v-13.24h-21.31ZM1994.3,520.07c-1.66,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2002.27,
    y: 504.64,
    width: 305.03,
    height: 41.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2002.27,
    y: 510.19,
    width: 305.03,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 2031.3,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 2006.05,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 2039.27,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 2266.1,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 2274.07,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 2299.17,
    y: 510.19,
    width: 4.57,
    height: 30.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 2180.32,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2180.07,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM2180.07,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2272.37,623.21v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.72,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.72-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM2180.07,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2180.07,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM2180.07,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M2180.07,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM2180.07,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M2180.07,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM2180.07,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M2180.04,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2147.28,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2139.23,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM2158.54,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM2179.91,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2180.17,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2201.54,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2212.81,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2220.85,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M2230.08,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM2154.91,595.59c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM2179.91,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2216.07,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M2144.87,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM2179.91,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M2180.04,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM2147.28,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM2139.23,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM2158.54,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM2179.91,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM2180.17,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM2201.54,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM2212.81,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM2220.85,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2182.55 641.63 2178.38 641.63 2176.29 645.24 2178.38 648.85 2182.55 648.85 2184.63 645.24 2182.55 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2182.51,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2196.76 633.69 2193.81 636.64 2194.89 640.67 2198.92 641.75 2201.87 638.8 2200.79 634.77 2196.76 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2199.29,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2201.19 618.03 2201.19 622.2 2204.81 624.29 2208.42 622.2 2208.42 618.03 2204.81 615.94 2201.19 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2204.81,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2193.26 603.82 2196.21 606.77 2200.24 605.69 2201.32 601.66 2198.37 598.71 2194.34 599.79 2193.26 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2195.84,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2177.6 599.38 2181.77 599.38 2183.86 595.77 2181.77 592.16 2177.6 592.16 2175.51 595.77 2177.6 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2177.64,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2163.39 607.32 2166.34 604.37 2165.26 600.34 2161.23 599.26 2158.28 602.21 2159.36 606.24 2163.39 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2160.86,604.74c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2158.95 622.98 2158.95 618.81 2155.34 616.72 2151.73 618.81 2151.73 622.98 2155.34 625.07 2158.95 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2155.34,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "2166.89 637.19 2163.94 634.24 2159.91 635.32 2158.83 639.35 2161.78 642.3 2165.81 641.22 2166.89 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2164.31,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-161",
    cx: 2180.07,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-168",
    cx: 2180.07,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M2289.86,582.05c-3.27,1.44-4.77,5.27-3.33,8.54l4.79,10.91c1.44,3.27,5.27,4.77,8.54,3.33,3.27-1.44,4.77-5.27,3.33-8.54l-4.79-10.91c-1.44-3.27-5.27-4.77-8.54-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M2299.55,604.13h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2295.55,586.79c.73,1.67-.03,3.62-1.7,4.35-1.67.73-3.62-.03-4.35-1.7-.73-1.67.03-3.62,1.7-4.35,1.67-.73,3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2294.88,587.08c.57,1.3-.02,2.82-1.32,3.4s-2.82-.02-3.4-1.32c-.57-1.3.02-2.82,1.32-3.4s2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2300.22,597.43c.73,1.67-.03,3.62-1.7,4.35s-3.62-.03-4.35-1.7c-.73-1.67.03-3.62,1.7-4.35,1.67-.73,3.62.03,4.35,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2299.56,597.72c.57,1.3-.02,2.82-1.32,3.4-1.3.57-2.82-.02-3.4-1.32-.57-1.3.02-2.82,1.32-3.4,1.3-.57,2.82.02,3.4,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M2299.55,604.13h0c-2.89,1.27-6.26-.05-7.53-2.94l-4.79-10.91c-1.27-2.89.05-6.26,2.94-7.53h0c2.89-1.27,6.26.05,7.53,2.94l4.79,10.91c1.27,2.89-.05,6.26-2.94,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M2069.56,581.76c-3.35-1.23-7.09.49-8.32,3.85l-4.11,11.18c-1.23,3.35.49,7.09,3.85,8.32,3.35,1.23,7.09-.49,8.32-3.85l4.11-11.18c1.23-3.35-.49-7.09-3.85-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M2061.23,604.4h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2070.37,589.12c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24.63-1.71,2.53-2.59,4.24-1.96s2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2069.69,588.87c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53,1.34.49,2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M2066.36,600.03c-.63,1.71-2.53,2.59-4.24,1.96-1.71-.63-2.59-2.53-1.96-4.24.63-1.71,2.53-2.59,4.24-1.96s2.59,2.53,1.96,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2065.68,599.78c-.49,1.34-1.97,2.02-3.31,1.53-1.34-.49-2.02-1.97-1.53-3.31.49-1.34,1.97-2.02,3.31-1.53s2.02,1.97,1.53,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M2061.23,604.4h0c-2.96-1.09-4.48-4.38-3.39-7.34l4.11-11.18c1.09-2.96,4.38-4.48,7.34-3.39h0c2.96,1.09,4.48,4.38,3.39,7.34l-4.11,11.18c-1.09,2.96-4.38,4.48-7.34,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M2571.58,540l-6.29,4.47v49.81l6.29,4.47c2.35,1.67,5.28,2.59,8.3,2.59h155.42c3.01,0,5.94-.91,8.3-2.59l6.29-4.47h0v-49.81h0l-6.29-4.47c-2.35-1.67-5.28-2.59-8.3-2.59h-155.42c-3.02,0-5.94.91-8.3,2.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2632.68,
    y: 477.08,
    width: 49.81,
    height: 184.59,
    transform: "translate(2088.21 3226.96) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 2746.24,
    y: 546.8,
    width: 5.98,
    height: 1.31,
    transform: "translate(3296.69 -2201.77) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 2743.66,
    y: 546.61,
    width: 5.98,
    height: 1.71,
    transform: "translate(3294.11 -2199.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 2740.48,
    y: 546.48,
    width: 5.98,
    height: 1.96,
    transform: "translate(3290.93 -2196.01) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 2736.66,
    y: 546.27,
    width: 5.98,
    height: 2.38,
    transform: "translate(3287.11 -2192.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 2732.16,
    y: 546.06,
    width: 5.98,
    height: 2.79,
    transform: "translate(3282.61 -2187.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 2727.12,
    y: 545.93,
    width: 5.98,
    height: 3.05,
    transform: "translate(3277.56 -2182.65) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 2721.53,
    y: 545.73,
    width: 5.98,
    height: 3.46,
    transform: "translate(3271.98 -2177.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 2715.48,
    y: 545.62,
    width: 5.98,
    height: 3.67,
    transform: "translate(3265.93 -2171.01) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 2708.81,
    y: 545.52,
    width: 5.98,
    height: 3.88,
    transform: "translate(3259.26 -2164.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 2701.88,
    y: 545.36,
    width: 5.98,
    height: 4.19,
    transform: "translate(3252.33 -2157.41) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 2694.45,
    y: 545.29,
    width: 5.98,
    height: 4.34,
    transform: "translate(3244.9 -2149.98) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 2686.8,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(3237.24 -2142.33) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 2678.78,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(3229.23 -2134.31) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 2670.66,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(3221.11 -2126.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 2662.44,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(3212.89 -2117.97) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 2562.96,
    y: 546.8,
    width: 5.98,
    height: 1.31,
    transform: "translate(2018.49 3113.4) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 2565.53,
    y: 546.61,
    width: 5.98,
    height: 1.71,
    transform: "translate(2021.06 3115.98) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 2568.71,
    y: 546.48,
    width: 5.98,
    height: 1.96,
    transform: "translate(2024.24 3119.16) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 2572.54,
    y: 546.27,
    width: 5.98,
    height: 2.38,
    transform: "translate(2028.07 3122.99) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 2577.04,
    y: 546.06,
    width: 5.98,
    height: 2.79,
    transform: "translate(2032.57 3127.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 2582.08,
    y: 545.93,
    width: 5.98,
    height: 3.05,
    transform: "translate(2037.61 3132.53) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 2587.66,
    y: 545.73,
    width: 5.98,
    height: 3.46,
    transform: "translate(2043.19 3138.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 2593.71,
    y: 545.62,
    width: 5.98,
    height: 3.67,
    transform: "translate(2049.24 3144.16) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 2600.39,
    y: 545.52,
    width: 5.98,
    height: 3.88,
    transform: "translate(2055.92 3150.83) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 2607.31,
    y: 545.36,
    width: 5.98,
    height: 4.19,
    transform: "translate(2062.84 3157.76) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 2614.75,
    y: 545.29,
    width: 5.98,
    height: 4.34,
    transform: "translate(2070.28 3165.2) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 2622.4,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(2077.93 3172.85) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 2630.42,
    y: 545.15,
    width: 5.98,
    height: 4.63,
    transform: "translate(2085.95 3180.86) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 2638.53,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(2094.06 3188.98) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 2646.76,
    y: 545.04,
    width: 5.98,
    height: 4.83,
    transform: "translate(2102.29 3197.2) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 2654.6,
    y: 545.08,
    width: 5.98,
    height: 4.76,
    transform: "translate(2110.13 3205.05) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 2746.24,
    y: 590.64,
    width: 5.98,
    height: 1.31,
    transform: "translate(3340.52 -2157.94) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 2743.66,
    y: 590.44,
    width: 5.98,
    height: 1.71,
    transform: "translate(3337.95 -2155.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 2740.48,
    y: 590.31,
    width: 5.98,
    height: 1.96,
    transform: "translate(3334.77 -2152.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 2736.66,
    y: 590.1,
    width: 5.98,
    height: 2.38,
    transform: "translate(3330.94 -2148.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 2732.16,
    y: 589.9,
    width: 5.98,
    height: 2.79,
    transform: "translate(3326.44 -2143.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 2727.12,
    y: 589.77,
    width: 5.98,
    height: 3.05,
    transform: "translate(3321.4 -2138.81) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 2721.53,
    y: 589.56,
    width: 5.98,
    height: 3.46,
    transform: "translate(3315.82 -2133.23) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 2715.48,
    y: 589.46,
    width: 5.98,
    height: 3.67,
    transform: "translate(3309.77 -2127.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 2708.81,
    y: 589.36,
    width: 5.98,
    height: 3.88,
    transform: "translate(3303.09 -2120.51) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 2701.88,
    y: 589.2,
    width: 5.98,
    height: 4.19,
    transform: "translate(3296.17 -2113.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 2694.45,
    y: 589.12,
    width: 5.98,
    height: 4.34,
    transform: "translate(3288.73 -2106.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 2686.8,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(3281.08 -2098.49) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 2678.78,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(3273.06 -2090.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 2670.66,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(3264.95 -2082.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 2662.44,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(3256.72 -2074.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 2562.96,
    y: 590.64,
    width: 5.98,
    height: 1.31,
    transform: "translate(1974.65 3157.24) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 2565.53,
    y: 590.44,
    width: 5.98,
    height: 1.71,
    transform: "translate(1977.23 3159.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 2568.71,
    y: 590.31,
    width: 5.98,
    height: 1.96,
    transform: "translate(1980.41 3163) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 2572.54,
    y: 590.1,
    width: 5.98,
    height: 2.38,
    transform: "translate(1984.23 3166.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 2577.04,
    y: 589.9,
    width: 5.98,
    height: 2.79,
    transform: "translate(1988.73 3171.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 2582.08,
    y: 589.77,
    width: 5.98,
    height: 3.05,
    transform: "translate(1993.77 3176.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 2587.66,
    y: 589.56,
    width: 5.98,
    height: 3.46,
    transform: "translate(1999.36 3181.95) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 2593.71,
    y: 589.46,
    width: 5.98,
    height: 3.67,
    transform: "translate(2005.41 3188) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 2600.39,
    y: 589.36,
    width: 5.98,
    height: 3.88,
    transform: "translate(2012.08 3194.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 2607.31,
    y: 589.2,
    width: 5.98,
    height: 4.19,
    transform: "translate(2019.01 3201.6) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 2614.75,
    y: 589.12,
    width: 5.98,
    height: 4.34,
    transform: "translate(2026.44 3209.03) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 2622.4,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(2034.1 3216.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 2630.42,
    y: 588.98,
    width: 5.98,
    height: 4.63,
    transform: "translate(2042.11 3224.7) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 2638.53,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(2050.23 3232.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 2646.76,
    y: 588.88,
    width: 5.98,
    height: 4.83,
    transform: "translate(2058.45 3241.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 2654.6,
    y: 588.91,
    width: 5.98,
    height: 4.76,
    transform: "translate(2066.29 3248.88) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 2637.61,
    y: 477.08,
    width: 39.96,
    height: 184.59,
    transform: "translate(2088.21 3226.96) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2565.68,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2571.15,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2576.61,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2582.08,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2589.13,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2596.18,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2603.22,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2610.27,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2617.32,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2625.53,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2633.74,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2641.96,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2650.17,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2743.63,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2738.16,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2732.69,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2727.23,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2720.18,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2713.13,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2706.08,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2699.04,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2691.99,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2683.78,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2675.56,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2667.35,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2659.14,577.16c-.18.41-.21.9-.09,1.34l1.2,4.49c.23.85.92,1.29,1.55.98.63-.31.95-1.25.72-2.1l-.82-3.04c-.12-.44-.09-.93.09-1.34l3.37-7.78h-2.8l-3.23,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2749.49,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2744.03,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2738.56,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2733.09,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2726.05,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2719,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2711.95,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2704.9,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2697.86,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2689.64,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2681.43,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2673.22,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2665.01,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2571.55,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2577.02,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2582.48,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2587.95,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2594.99,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2602.04,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2609.09,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2616.14,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2623.19,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2631.4,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2639.61,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2647.82,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2656.04,561.59c.18-.41.21-.9.09-1.34l-1.2-4.49c-.23-.85-.92-1.29-1.55-.98-.63.31-.95,1.25-.72,2.1l.82,3.04c.12.44.09.93-.09,1.34l-3.37,7.78h2.8l3.23-7.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2656.83,
    y: 477.08,
    width: 1.52,
    height: 184.59,
    transform: "translate(2088.21 3226.96) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2656.83,
    y: 494.83,
    width: 1.52,
    height: 184.59,
    transform: "translate(2070.46 3244.71) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2656.83,
    y: 459.33,
    width: 1.52,
    height: 184.59,
    transform: "translate(2105.96 3209.22) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 2565.29,
    y: 537.41,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "2932.67 541.26 2932.67 581.99 2956.2 604.79 2981.75 604.79 2991.74 591.32 3158.21 591.32 3168.2 604.79 3193.75 604.79 3217.28 581.99 3217.28 541.26 2932.67 541.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M3199.78,591.07l-5.05-13.55c-2.32-6.23-7.8-8.64-12.24-5.39h0c-4.44,3.25-6.17,10.93-3.85,17.16l2.97,7.98h-98.58v-.59h-16.12v.59h-98.58l2.97-7.98c2.32-6.23.59-13.91-3.85-17.15h0c-4.44-3.25-9.92-.83-12.24,5.4l-5.04,13.55c-2.32,6.23-.59,13.9,3.85,17.15h0c4.01,2.93,8.83,1.22,11.45-3.7h22.85v3.63h8.98v3.63h14.23v3.63h15.72v3.63h20.23v3.63h19.44v2.37h16.12v-2.37h19.44v-3.63h20.23v-3.63h15.73v-3.63h14.22v-3.63h8.98v-3.63h22.85c2.61,4.92,7.44,6.63,11.45,3.7h0c4.44-3.25,6.17-10.93,3.85-17.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3245.84 546.38 2440.82 546.38 2334.9 494.2 2022.7 494.2 2022.7 473.89 3245.84 473.89 3245.84 546.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2466.34,
    y: 490.87,
    width: 779.5,
    height: 55.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2466.34,
    y: 498.25,
    width: 779.5,
    height: 40.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M262.38,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM262.38,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M354.68,623.21v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM262.38,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M262.38,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM262.38,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M312.26,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.63-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-221",
    cx: 262.38,
    cy: 620.5,
    r: 31.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M262.38,569.85c-27.98,0-50.66,22.68-50.66,50.66s22.68,50.66,50.66,50.66,50.66-22.68,50.66-50.66-22.68-50.66-50.66-50.66ZM262.38,668.11c-26.29,0-47.61-21.31-47.61-47.61s21.31-47.61,47.61-47.61,47.61,21.31,47.61,47.61-21.31,47.61-47.61,47.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M262.38,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM262.38,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M312.26,628.74c-1.08,1.93-2.53,3.14-4.13,3.14-3.34,0-6.05-5.16-6.05-11.52s2.71-11.52,6.05-11.52c1.57,0,2.99,1.17,4.07,3.04-1.32-7.68-4.36-14.76-8.73-20.84.61,2.14.44,4.02-.7,5.16-2.36,2.36-7.93.63-12.43-3.86-4.5-4.5-6.23-10.06-3.86-12.43,1.12-1.12,2.96-1.29,5.06-.72-6.11-4.32-13.22-7.3-20.92-8.56,1.93,1.08,3.13,2.53,3.13,4.13,0,3.34-5.16,6.05-11.52,6.05s-11.52-2.71-11.52-6.05c0-1.57,1.17-2.99,3.04-4.07-7.68,1.32-14.76,4.36-20.84,8.73,2.14-.61,4.02-.44,5.16.7,2.36,2.36.63,7.93-3.86,12.43-4.5,4.5-10.06,6.23-12.43,3.86-1.12-1.12-1.29-2.96-.72-5.06-4.32,6.11-7.3,13.22-8.56,20.92,1.08-1.93,2.53-3.14,4.13-3.14,3.34,0,6.05,5.16,6.05,11.52s-2.71,11.52-6.05,11.52c-1.57,0-2.99-1.17-4.07-3.04,1.32,7.68,4.36,14.76,8.73,20.84-.61-2.14-.44-4.02.7-5.16,2.37-2.36,7.93-.64,12.43,3.86,4.5,4.5,6.23,10.06,3.86,12.43-1.12,1.12-2.96,1.29-5.06.72,6.11,4.32,13.22,7.3,20.92,8.56-1.93-1.08-3.14-2.53-3.14-4.13,0-3.34,5.16-6.05,11.52-6.05s11.52,2.71,11.52,6.05c0,1.58-1.17,2.99-3.04,4.07,7.68-1.32,14.76-4.36,20.84-8.73-2.14.61-4.02.44-5.16-.7-2.36-2.37-.63-7.93,3.86-12.43,4.5-4.5,10.06-6.23,12.43-3.86,1.12,1.12,1.29,2.96.72,5.06,4.32-6.11,7.3-13.22,8.56-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M262.38,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM262.38,669.46c-27.04,0-48.95-21.92-48.95-48.95s21.92-48.95,48.95-48.95,48.95,21.92,48.95,48.95-21.92,48.95-48.95,48.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-223",
    cx: 262.38,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "264.85 641.63 260.68 641.63 258.6 645.24 260.68 648.85 264.85 648.85 266.94 645.24 264.85 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M264.81,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "279.06 633.69 276.11 636.64 277.19 640.67 281.22 641.75 284.17 638.8 283.09 634.77 279.06 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M281.59,636.27c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "283.5 618.03 283.5 622.2 287.11 624.29 290.73 622.2 290.73 618.03 287.11 615.94 283.5 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M287.11,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "275.56 603.82 278.51 606.77 282.54 605.69 283.62 601.66 280.67 598.71 276.64 599.79 275.56 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M278.15,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "259.9 599.38 264.08 599.38 266.16 595.77 264.08 592.16 259.9 592.16 257.82 595.77 259.9 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M259.94,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "245.7 607.32 248.65 604.37 247.57 600.34 243.54 599.26 240.59 602.21 241.67 606.24 245.7 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M243.17,604.74c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "241.26 622.98 241.26 618.81 237.65 616.72 234.03 618.81 234.03 622.98 237.65 625.07 241.26 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M237.65,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "249.19 637.19 246.24 634.24 242.21 635.32 241.13 639.35 244.08 642.3 248.11 641.22 249.19 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M246.61,639.72c-.8.8-2.09.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-227",
    cx: 262.38,
    cy: 620.5,
    r: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3208.05,514.86h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3220.11,
    y: 600.36,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 3214.46,
    y: 479.89,
    width: 11.28,
    height: 156.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M3243.22,540.55h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.72v-7.36c0-3.16,2.56-5.72,5.72-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3243.87,
    y: 541.96,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3243.98,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M3242.68,541.96h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3242.27,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M3240.97,541.96h.21c.29,0,.52.23.52.52v14.94c0,.29-.23.52-.52.52h-.21c-.29,0-.52-.23-.52-.52v-14.94c0-.29.23-.52.52-.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3240.56,
    y: 542.27,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M3243.22,518.13h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3243.87,
    y: 519.53,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M3244.32,519.85h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3242.16,
    y: 519.53,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M3242.61,519.85h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3240.45,
    y: 519.53,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M3240.9,519.85h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 3075.22,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M3074.97,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM3074.97,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3167.27,623.21v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.72,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM3074.97,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M3074.97,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM3074.97,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M3074.97,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM3074.97,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M3074.97,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM3074.97,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M3074.94,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM3042.18,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM3034.13,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM3053.44,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM3074.81,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM3075.07,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3096.44,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM3107.71,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3115.75,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M3124.98,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM3049.81,595.59c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08s8.98-5.56,11.08-3.45c2.11,2.11.57,7.07-3.45,11.08ZM3074.81,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3110.97,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M3039.77,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM3074.81,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M3074.94,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM3042.18,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM3034.13,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM3053.44,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08s7.07-.57,11.08,3.45c4.01,4.01,5.56,8.98,3.45,11.09ZM3074.81,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.28-2.42-10.28-5.4,4.6-5.4,10.28-5.4ZM3075.07,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM3096.44,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM3107.71,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM3115.75,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3077.45 641.63 3073.28 641.63 3071.19 645.24 3073.28 648.85 3077.45 648.85 3079.53 645.24 3077.45 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3077.41,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3091.66 633.69 3088.71 636.64 3089.79 640.67 3093.82 641.75 3096.77 638.8 3095.69 634.77 3091.66 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3094.19,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3096.09 618.03 3096.09 622.2 3099.71 624.29 3103.32 622.2 3103.32 618.03 3099.71 615.94 3096.09 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3099.71,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3088.16 603.82 3091.11 606.77 3095.14 605.69 3096.22 601.66 3093.27 598.71 3089.24 599.79 3088.16 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3090.74,601.29c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3072.5 599.38 3076.67 599.38 3078.76 595.77 3076.67 592.16 3072.5 592.16 3070.41 595.77 3072.5 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3072.54,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3058.29 607.32 3061.24 604.37 3060.16 600.34 3056.13 599.26 3053.18 602.21 3054.26 606.24 3058.29 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3055.76,604.74c-.8-.8-.8-2.1,0-2.89s2.09-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3053.85 622.98 3053.85 618.81 3050.24 616.72 3046.63 618.81 3046.63 622.98 3050.24 625.07 3053.85 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3050.24,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "3061.79 637.19 3058.84 634.24 3054.81 635.32 3053.73 639.35 3056.68 642.3 3060.71 641.22 3061.79 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M3059.21,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-229",
    cx: 3074.97,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 3074.97,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1167.07,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 1029.92,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1403.53,594.87l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 1266.38,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1115.45,
    y: 546.32,
    width: 65.43,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1107.55,
    y: 552.12,
    width: 81.24,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 1099.64,
    y: 557.92,
    width: 97.06,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1091.73,
    y: 563.71,
    width: 112.87,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1083.83,
    y: 569.51,
    width: 128.68,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1075.92,
    y: 575.31,
    width: 144.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1068.01,
    y: 581.11,
    width: 160.31,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1060.11,
    y: 586.91,
    width: 176.12,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 1052.2,
    y: 592.7,
    width: 191.94,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1044.29,
    y: 598.5,
    width: 207.75,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1036.39,
    y: 604.3,
    width: 223.57,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1028.48,
    y: 610.1,
    width: 239.38,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1124.64,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1164.51,
    y: 545.07,
    width: 7.19,
    height: 72.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1129.34,609.89l7.54,34.13c.42,1.9,1.44,3.14,2.58,3.14h17.42c1.14,0,2.16-1.25,2.58-3.14l7.54-34.13c.72-3.26-.62-6.8-2.58-6.8h-32.49c-1.96,0-3.3,3.54-2.58,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1129.46,629.33c-4.44.38-8.02,3.25-9.6,7.11l-100.9,8.57.88,10.35,100.9-8.57c2.21,3.53,6.23,5.77,10.66,5.39,6.31-.54,10.99-6.09,10.46-12.4-.54-6.31-6.09-10.99-12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1166.88,629.33c4.44.38,8.02,3.25,9.6,7.11l100.9,8.57-.88,10.35-100.9-8.57c-2.21,3.53-6.23,5.77-10.66,5.39-6.31-.54-10.99-6.09-10.46-12.4.54-6.31,6.09-10.99,12.4-10.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 1029.92,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1029.67,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1029.67,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1121.97,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.86-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.5-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1029.67,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1029.67,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1029.67,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1029.67,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1029.67,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M1029.67,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1029.67,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1029.64,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM996.87,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM988.83,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1008.14,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1029.51,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1029.77,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1051.14,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1062.41,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1070.45,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1079.68,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1004.51,595.59c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45s.57,7.07-3.45,11.08ZM1029.51,585.13c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1065.67,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M994.47,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1029.51,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1029.64,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM996.87,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM988.83,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1008.14,656.75c-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1029.51,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1029.77,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1051.14,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1062.41,653.12c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.09-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1070.45,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1032.14 641.63 1027.97 641.63 1025.89 645.24 1027.97 648.85 1032.14 648.85 1034.23 645.24 1032.14 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1032.1,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1046.35 633.69 1043.4 636.64 1044.48 640.67 1048.51 641.75 1051.46 638.8 1050.38 634.77 1046.35 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1048.88,636.27c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1050.79 618.03 1050.79 622.2 1054.4 624.29 1058.02 622.2 1058.02 618.03 1054.4 615.94 1050.79 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1054.4,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1042.85 603.82 1045.8 606.77 1049.83 605.69 1050.91 601.66 1047.96 598.71 1043.93 599.79 1042.85 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1045.44,601.29c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.09.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1027.19 599.38 1031.37 599.38 1033.45 595.77 1031.37 592.16 1027.19 592.16 1025.11 595.77 1027.19 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1027.23,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1012.99 607.32 1015.94 604.37 1014.86 600.34 1010.83 599.26 1007.88 602.21 1008.96 606.24 1012.99 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1010.46,604.74c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1008.55 622.98 1008.55 618.81 1004.94 616.72 1001.32 618.81 1001.32 622.98 1004.94 625.07 1008.55 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1004.94,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1016.48 637.19 1013.53 634.24 1009.5 635.32 1008.42 639.35 1011.37 642.3 1015.4 641.22 1016.48 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1013.9,639.72c-.8.8-2.09.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 1029.67,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-66",
    cx: 1029.67,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 1266.61,
    cy: 620.5,
    r: 39.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1266.37,529.61c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1266.37,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1358.66,623.21v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.82l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.23c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.8c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.58,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.23c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1266.37,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1266.37,538.14c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1266.37,667.6c-26.01,0-47.09-21.09-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.09,47.09,47.09-21.08,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1266.37,563.02c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1266.37,670.39c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M1266.37,568.42c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1266.37,668.6c-26.56,0-48.1-21.53-48.1-48.1s21.53-48.1,48.1-48.1,48.1,21.53,48.1,48.1-21.53,48.1-48.1,48.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1266.33,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1233.57,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1225.52,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1244.84,656.75c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1266.2,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1266.46,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1287.83,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1299.1,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1307.14,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1316.37,613.93c-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c1.02,3.42,2.38,6.7,4.1,9.78-.16-.97-.27-1.98-.27-3.05,0-5.68,2.42-10.27,5.4-10.27s5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28c-.08,0-.15-.04-.22-.04,9.53,11.72,24.35,19.29,41.03,19.29s31.75-7.7,41.27-19.59c-.15.03-.3.09-.46.09-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28c0,1.21-.13,2.36-.33,3.44,1.75-3.11,3.13-6.44,4.16-9.91ZM1241.2,595.59c-4.01,4.01-8.98,5.56-11.08,3.45s-.57-7.07,3.45-11.08c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1266.2,585.13c-5.67,0-10.28-2.42-10.28-5.4s4.6-5.4,10.28-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1302.37,598.85c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.97-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M1231.16,599.69c-.39-.15-.75-.36-1.04-.65-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,1.71,1.71.99,5.29-1.47,8.72,7.16-2.89,14.98-4.49,23.18-4.49s15.9,1.58,23.02,4.43c-2.53-3.47-3.28-7.11-1.55-8.84,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-.29.3-.66.5-1.05.66,5.79,3.96,10.87,8.87,15.03,14.51,0-.03.02-.06.03-.08-3.24-24.77-24.38-43.92-50.04-43.92s-46.79,19.14-50.04,43.91c.01.05.04.09.05.14,4.1-5.58,9.11-10.45,14.81-14.39ZM1266.2,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1266.33,570.02c-27.9,0-50.52,22.62-50.52,50.52s22.62,50.52,50.52,50.52,50.52-22.62,50.52-50.52-22.62-50.52-50.52-50.52ZM1233.57,587.95c4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08-4.01,4.01-8.97,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08ZM1225.52,630.94c-2.98,0-5.4-4.6-5.4-10.28s2.42-10.27,5.4-10.27,5.4,4.6,5.4,10.27-2.42,10.28-5.4,10.28ZM1244.84,656.75c-2.11,2.11-7.07.57-11.09-3.45-4.01-4.01-5.56-8.98-3.45-11.08,2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09ZM1266.2,574.33c5.68,0,10.27,2.42,10.27,5.4s-4.6,5.4-10.27,5.4-10.27-2.42-10.27-5.4,4.6-5.4,10.27-5.4ZM1266.46,666.75c-5.67,0-10.27-2.42-10.27-5.4s4.6-5.4,10.27-5.4,10.27,2.42,10.27,5.4-4.6,5.4-10.27,5.4ZM1287.83,584.32c2.11-2.11,7.07-.57,11.08,3.45,4.01,4.01,5.56,8.98,3.45,11.09-2.11,2.11-7.07.57-11.08-3.45-4.01-4.01-5.56-8.97-3.45-11.08ZM1299.1,653.12c-4.01,4.01-8.98,5.56-11.08,3.45-2.11-2.11-.57-7.07,3.45-11.08,4.01-4.01,8.98-5.56,11.08-3.45,2.11,2.11.57,7.07-3.45,11.08ZM1307.14,630.68c-2.98,0-5.4-4.6-5.4-10.27s2.42-10.28,5.4-10.28,5.4,4.6,5.4,10.28-2.42,10.27-5.4,10.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1268.84 641.63 1264.67 641.63 1262.58 645.24 1264.67 648.85 1268.84 648.85 1270.93 645.24 1268.84 641.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1268.8,645.24c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1283.05 633.69 1280.1 636.64 1281.18 640.67 1285.21 641.75 1288.16 638.8 1287.08 634.77 1283.05 633.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1285.58,636.27c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1287.49 618.03 1287.49 622.2 1291.1 624.29 1294.71 622.2 1294.71 618.03 1291.1 615.94 1287.49 618.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1291.1,618.07c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1279.55 603.82 1282.5 606.77 1286.53 605.69 1287.61 601.66 1284.66 598.71 1280.63 599.79 1279.55 603.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1282.13,601.29c.8-.8,2.1-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1263.89 599.38 1268.06 599.38 1270.15 595.77 1268.06 592.16 1263.89 592.16 1261.81 595.77 1263.89 599.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1263.93,595.77c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1249.68 607.32 1252.63 604.37 1251.55 600.34 1247.52 599.26 1244.57 602.21 1245.65 606.24 1249.68 607.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1247.15,604.74c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1245.25 622.98 1245.25 618.81 1241.63 616.72 1238.02 618.81 1238.02 622.98 1241.63 625.07 1245.25 622.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1241.63,622.94c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "1253.18 637.19 1250.23 634.24 1246.2 635.32 1245.12 639.35 1248.07 642.3 1252.1 641.22 1253.18 637.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M1250.6,639.72c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 1266.37,
    cy: 620.5,
    r: 18.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 1266.37,
    cy: 620.5,
    r: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1410.53,682.15c-6.08-2.73-23.11-5.04-24.13-26.15-.48-9.85-.67-34.51-.81-46h-3.32v46.37c0,11.72,1.6,14.72,6.78,23.52,3.47,5.88,10.51,9.59,17.74,6.9l3.55-1.32c1.69-.63,1.82-2.59.19-3.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 1184.08,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1355.7,528.21c0,3.8-3.08,6.88-6.88,6.88s-6.88-3.08-6.88-6.88,3.08-6.88,6.88-6.88,6.88,3.08,6.88,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1381.9,620.5h-11.99c0-57.04-46.41-103.45-103.45-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M1375.66,620.5h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 947.3,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 1112.04,
    cy: 528.21,
    r: 6.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1145.12,620.5h-11.99c0-57.04-46.41-103.45-103.46-103.45s-103.46,46.41-103.46,103.45h-11.99c0-63.66,51.79-115.44,115.45-115.44s115.45,51.79,115.45,115.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M1138.88,620.5h-4.8c0-57.57-46.84-104.41-104.41-104.41s-104.41,46.84-104.41,104.41h-4.8c0-60.22,48.99-109.21,109.21-109.21s109.21,48.99,109.21,109.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1408.91,576.09l-6.29,4.39v48.83l6.29,4.39c2.35,1.64,5.28,2.54,8.3,2.54h155.42c3.01,0,5.94-.89,8.3-2.54l6.29-4.39h0v-48.83h0l-6.29-4.39c-2.35-1.64-5.28-2.54-8.3-2.54h-155.42c-3.02,0-5.94.89-8.3,2.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 1470.5,
    y: 512.59,
    width: 48.83,
    height: 184.59,
    transform: "translate(890.02 2099.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1583.63,
    y: 582.75,
    width: 5.86,
    height: 1.31,
    transform: "translate(2169.97 -1003.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1581.05,
    y: 582.55,
    width: 5.86,
    height: 1.71,
    transform: "translate(2167.39 -1000.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1577.87,
    y: 582.43,
    width: 5.86,
    height: 1.96,
    transform: "translate(2164.21 -997.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1574.04,
    y: 582.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(2160.38 -993.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1569.55,
    y: 582.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(2155.88 -989.07) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1564.5,
    y: 581.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(2150.84 -984.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1558.92,
    y: 581.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(2145.26 -978.44) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1552.87,
    y: 581.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(2139.21 -972.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1546.2,
    y: 581.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(2132.54 -965.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1539.27,
    y: 581.31,
    width: 5.86,
    height: 4.19,
    transform: "translate(2125.61 -958.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1531.84,
    y: 581.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(2118.17 -951.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1524.18,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(2110.52 -943.71) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1516.17,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(2102.51 -935.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1508.05,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(2094.39 -927.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1499.83,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(2086.17 -919.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 1400.34,
    y: 582.75,
    width: 5.86,
    height: 1.31,
    transform: "translate(819.87 1986.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1402.92,
    y: 582.55,
    width: 5.86,
    height: 1.71,
    transform: "translate(822.44 1989.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 1406.1,
    y: 582.43,
    width: 5.86,
    height: 1.96,
    transform: "translate(825.62 1992.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 1409.93,
    y: 582.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(829.45 1996.27) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 1414.43,
    y: 582.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(833.95 2000.76) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1419.47,
    y: 581.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(838.99 2005.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1425.05,
    y: 581.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(844.57 2011.39) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1431.1,
    y: 581.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(850.62 2017.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 1437.77,
    y: 581.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(857.29 2024.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1444.7,
    y: 581.31,
    width: 5.86,
    height: 4.19,
    transform: "translate(864.22 2031.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1452.14,
    y: 581.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(871.66 2038.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 1459.79,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(879.31 2046.13) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 1467.8,
    y: 581.09,
    width: 5.86,
    height: 4.63,
    transform: "translate(887.33 2054.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 1475.92,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(895.44 2062.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 1484.14,
    y: 580.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(903.67 2070.48) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 1491.99,
    y: 581.03,
    width: 5.86,
    height: 4.76,
    transform: "translate(911.51 2078.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 1583.63,
    y: 625.72,
    width: 5.86,
    height: 1.31,
    transform: "translate(2212.93 -960.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 1581.05,
    y: 625.52,
    width: 5.86,
    height: 1.71,
    transform: "translate(2210.36 -957.61) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 1577.87,
    y: 625.39,
    width: 5.86,
    height: 1.96,
    transform: "translate(2207.18 -954.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1574.04,
    y: 625.19,
    width: 5.86,
    height: 2.38,
    transform: "translate(2203.35 -950.6) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 1569.55,
    y: 624.98,
    width: 5.86,
    height: 2.79,
    transform: "translate(2198.85 -946.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1564.5,
    y: 624.85,
    width: 5.86,
    height: 3.05,
    transform: "translate(2193.81 -941.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1558.92,
    y: 624.64,
    width: 5.86,
    height: 3.46,
    transform: "translate(2188.23 -935.47) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 1552.87,
    y: 624.54,
    width: 5.86,
    height: 3.67,
    transform: "translate(2182.18 -929.42) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 1546.2,
    y: 624.44,
    width: 5.86,
    height: 3.88,
    transform: "translate(2175.5 -922.75) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1539.27,
    y: 624.28,
    width: 5.86,
    height: 4.19,
    transform: "translate(2168.58 -915.82) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 1531.84,
    y: 624.2,
    width: 5.86,
    height: 4.34,
    transform: "translate(2161.14 -908.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 1524.18,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(2153.49 -900.74) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 1516.17,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(2145.47 -892.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 1508.05,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(2137.36 -884.6) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 1499.83,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(2129.13 -876.38) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1400.34,
    y: 625.72,
    width: 5.86,
    height: 1.31,
    transform: "translate(776.9 2029.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1402.92,
    y: 625.52,
    width: 5.86,
    height: 1.71,
    transform: "translate(779.47 2032.23) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1406.1,
    y: 625.39,
    width: 5.86,
    height: 1.96,
    transform: "translate(782.65 2035.41) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1409.93,
    y: 625.19,
    width: 5.86,
    height: 2.38,
    transform: "translate(786.48 2039.23) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1414.43,
    y: 624.98,
    width: 5.86,
    height: 2.79,
    transform: "translate(790.98 2043.73) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 1419.47,
    y: 624.85,
    width: 5.86,
    height: 3.05,
    transform: "translate(796.02 2048.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1425.05,
    y: 624.64,
    width: 5.86,
    height: 3.46,
    transform: "translate(801.61 2054.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1431.1,
    y: 624.54,
    width: 5.86,
    height: 3.67,
    transform: "translate(807.66 2060.41) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1437.77,
    y: 624.44,
    width: 5.86,
    height: 3.88,
    transform: "translate(814.33 2067.08) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1444.7,
    y: 624.28,
    width: 5.86,
    height: 4.19,
    transform: "translate(821.26 2074.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1452.14,
    y: 624.2,
    width: 5.86,
    height: 4.34,
    transform: "translate(828.69 2081.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1459.79,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(836.34 2089.09) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1467.8,
    y: 624.06,
    width: 5.86,
    height: 4.63,
    transform: "translate(844.36 2097.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1475.92,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(852.48 2105.23) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1484.14,
    y: 623.96,
    width: 5.86,
    height: 4.83,
    transform: "translate(860.7 2113.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1491.99,
    y: 624,
    width: 5.86,
    height: 4.76,
    transform: "translate(868.54 2121.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1475.33,
    y: 512.59,
    width: 39.17,
    height: 184.59,
    transform: "translate(890.02 2099.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1420.11,616.96l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1420.11,607.5l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1420.11,598.05l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1420.11,588.59l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 1402.62,
    y: 573.56,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M386.51,477.54h0c-2.95,0-5.34-2.39-5.34-5.34v-178.18c0-2.95,2.39-5.34,5.34-5.34h0c2.95,0,5.34,2.39,5.34,5.34v178.18c0,2.95-2.39,5.34-5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 563.95,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 586.37,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 608.79,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 631.22,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 653.64,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 586.37,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 608.79,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 631.22,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 653.64,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 676.06,
    y: 512.34,
    width: 9.63,
    height: 47.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 555.69,
    y: 516.36,
    width: 138.25,
    height: 61.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 551.35,
    y: 525.89,
    width: 11.28,
    height: 55.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 687.01,
    y: 525.89,
    width: 11.28,
    height: 55.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 1619.06,
    y: 600.36,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M1607,491.73h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1642.18,517.42h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.71v-7.36c0-3.16,2.56-5.71,5.72-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1642.82,
    y: 518.82,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1643.28,519.14h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1641.11,
    y: 518.82,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1641.22,
    y: 519.14,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1639.4,
    y: 518.82,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1639.51,
    y: 519.14,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1642.18,495h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.72-2.56-5.72-5.72v-7.36c0-3.16,2.56-5.72,5.72-5.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1642.82,
    y: 496.4,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1643.28,496.72h.14c.19,0,.35.16.35.35v3.85c0,.19-.16.35-.35.35h-.14c-.19,0-.35-.16-.35-.35v-3.85c0-.19.16-.35.35-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1641.11,
    y: 496.4,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1641.22,
    y: 496.72,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1639.4,
    y: 496.4,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1639.51,
    y: 496.72,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M249.69,312.66c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M86.08,352.79c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M123.71,256.39h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 273,
    y: 256.39,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M273,341.73v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M136.22,353.37l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.59c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M367.39,523.4v108.78c0,15.09,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M431.14,522.33h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M415.86,552.21h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 431.65,
    cy: 535.43,
    r: 34.46,
    transform: "translate(-194.69 251.33) rotate(-26.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 431.65,
    cy: 535.43,
    r: 27.78,
    transform: "translate(-199.18 261.45) rotate(-27.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 431.65,
    cy: 535.43,
    r: 21.32,
    transform: "translate(-150.29 901.99) rotate(-83.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 431.65,
    cy: 535.43,
    r: 17.19,
    transform: "translate(-220.21 316.13) rotate(-32.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M397.65,282.02c0-4.55-3.69-8.23-8.23-8.23s-8.23,3.69-8.23,8.23v49.12h16.47v-49.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1613.42,
    y: 468.56,
    width: 11.28,
    height: 167.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M2325.21,689.52c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.79v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M2307.52,531.52l-31.92-31.85c-5.06-5.04-11.91-7.88-19.05-7.88h-163.44c-2.94,0-5.33,2.39-5.33,5.33h0c0,2.94,2.39,5.33,5.33,5.33h163.44c4.32,0,8.46,1.71,11.52,4.76l31.92,31.85c3.07,3.06,4.79,7.21,4.79,11.55v22.3h10.66v-22.3c0-7.16-2.85-14.03-7.92-19.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M3200.13,695.77c-1.29,0-2.43-.94-2.63-2.26-.07-.46-7.14-46.78-7.14-89.78v-51.85c0-1.47,1.19-2.66,2.66-2.66s2.66,1.19,2.66,2.66v51.85c0,42.59,7.01,88.52,7.08,88.97.22,1.45-.77,2.82-2.23,3.04-.14.02-.27.03-.41.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "3179.5 541.26 3172.34 541.26 3172.34 486.41 3190.36 486.41 3179.5 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "3179.5 541.26 3172.34 541.26 3172.34 486.41 3190.36 486.41 3179.5 541.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "2970.45 541.26 2977.61 541.26 2977.61 486.41 2959.59 486.41 2970.45 541.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "2970.45 541.26 2977.61 541.26 2977.61 486.41 2959.59 486.41 2970.45 541.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M3190.36,579.18h-10.66v-22.3c0-4.36-1.7-8.47-4.79-11.55l-31.92-31.85c-3.08-3.07-7.17-4.76-11.52-4.76h-112.98c-4.35,0-8.44,1.69-11.52,4.76l-31.93,31.85c-3.09,3.08-4.79,7.18-4.79,11.55v22.3h-10.66v-22.3c0-7.21,2.81-13.99,7.92-19.09l31.93-31.85c5.09-5.08,11.85-7.88,19.05-7.88h112.98c7.19,0,13.96,2.8,19.05,7.88l31.92,31.85c5.11,5.1,7.92,11.88,7.92,19.09v22.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 443.89,
    width: 1223.14,
    height: 474.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 450.79,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 450.79,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "455.12 8.79 1660.13 8.79 1660.13 6 450.79 6 450.79 468.56 455.12 468.56 455.12 8.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 2022.7,
    width: 1223.14,
    height: 474.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 2029.6,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2029.6,
    y: 6,
    width: 1209.34,
    height: 462.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "2033.93 8.79 3238.94 8.79 3238.94 6 2029.6 6 2029.6 468.56 2033.93 468.56 2033.93 8.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 2769.9,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 2463.99,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 2348.07,
    y: 563.56,
    width: 542.45,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 2348.07,
    y: 565.68,
    width: 542.45,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 2348.07,
    y: 568.15,
    width: 542.45,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 2348.07,
    y: 605.13,
    width: 542.45,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 2348.07,
    y: 607.24,
    width: 542.45,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 2348.07,
    y: 609.72,
    width: 542.45,
    height: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M356.34,242.6c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.34,176.26-74.34,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM240.22,359.48c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,358.62c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.36,431.18c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,21.96.15,32.77.43v-6.3c-10.81-.28-21.73-.43-32.77-.43Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 340,
    height: 82,
    transform: "translate(28.69 436.51)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "166.74 517.6 35.08 517.6 35.08 590.44 67.95 590.44 67.95 629.52 75.74 629.52 75.74 590.44 117.71 590.44 117.71 629.52 125.51 629.52 125.51 590.44 137.16 590.44 166.74 517.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "134.22 565.17 67.95 565.17 67.95 525 152.49 525 134.22 565.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 66,
    y: 622.94,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M122,204.92h219.58v24.37H97.83v-.21c0-13.34,10.83-24.16,24.16-24.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M358.5,202.96V46.77s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45l260.59-24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M358.5,213.3v-72.11s-216.57,51.79-239.8,66.84c-23.23,15.04-20.79,21.26-20.79,21.26l260.59-15.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M126.68,560.57h-46.44c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 66,
    y: 619.65,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M63.55,629.52H29.38c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 882.74,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 500.69,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 480.25,
    y: 563.56,
    width: 427.61,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 480.25,
    y: 565.68,
    width: 427.61,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 480.25,
    y: 568.15,
    width: 427.61,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 480.25,
    y: 605.13,
    width: 427.61,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 480.25,
    y: 607.24,
    width: 427.61,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 480.25,
    y: 609.72,
    width: 427.61,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 1576.02,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 1409.15,
    y: 507.07,
    width: 4.7,
    height: 111.66,
    rx: 2.28,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 1388.7,
    y: 563.56,
    width: 212.43,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 1388.7,
    y: 565.68,
    width: 212.43,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 1388.7,
    y: 568.15,
    width: 212.43,
    height: 8.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 1388.7,
    y: 605.13,
    width: 212.43,
    height: 18.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 1388.7,
    y: 607.24,
    width: 212.43,
    height: 13.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 1388.7,
    y: 609.72,
    width: 212.43,
    height: 8.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M356.34,242.61c-1.84-5.52-6.63-13.96-14.75-20.36v-7.91l16.92-1.04V46.77s-216.57,125.18-239.8,148.15c-23.23,22.97-20.79,32.45-20.79,32.45h.01c-.02.26-.03.53-.04.8-.04.3-.05.53-.04.71,0,.07,0,.13,0,.2v.21h.45c-19.11,34.37-68.71,171.94-68.71,198.37,0,38.17-2.8,68.16,2.8,89.95h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7.01,7-7.01,2.23,0,4.05-1.81,4.05-4.05v-86.68c0-27.98-8.79-120.51-11.79-129.5ZM240.22,359.48c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,358.62c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 822.69,
    y: 491.73,
    width: 53.37,
    height: 25.65,
    rx: 3.6,
    ry: 3.6,
    transform: "translate(1698.75 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 825.03,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1673.72 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 825.95,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1654.67 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 826.63,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1655.1 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 829.75,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1662.29 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 830.44,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1662.72 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 833.56,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1669.91 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 834.24,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1670.34 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 837.37,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1677.52 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 838.05,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1677.96 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 841.18,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1685.14 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 841.86,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1685.58 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 844.99,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1692.76 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 845.67,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1693.2 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 850.06,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1723.78 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 850.98,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1704.73 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 851.66,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1705.16 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 854.79,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1712.35 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 855.47,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1712.78 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 858.59,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1719.97 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 859.28,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1720.4 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 862.4,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1727.59 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 863.08,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1728.02 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 866.21,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1735.2 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 866.89,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1735.64 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 870.02,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1742.82 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 870.7,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1743.26 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M1424.91,491.73h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(2895.99 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1423.65,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2870.96 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1424.57,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2851.91 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1425.25,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2852.34 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1428.38,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2859.53 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1429.06,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2859.96 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1432.19,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2867.15 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1432.87,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2867.58 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1435.99,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2874.77 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1436.68,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2875.2 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1439.8,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2882.39 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1440.48,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2882.82 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 1443.61,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2890 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1444.29,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2890.44 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 1448.68,
    y: 494.44,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2921.02 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1449.6,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2901.97 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1450.28,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2902.41 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1453.41,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2909.59 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1454.09,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2910.02 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1457.22,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2917.21 1009.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1457.9,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2917.64 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1461.02,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2924.83 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1461.71,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2925.26 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1464.83,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2932.45 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1465.52,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2932.88 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1468.64,
    y: 496.37,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2940.07 1009.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1469.32,
    y: 496.69,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2940.5 998.03) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M2032.36,474.55h35.36c1.52,0,2.76,1.24,2.76,2.76v14.13c0,1.52-1.24,2.76-2.76,2.76h-35.36c-1.52,0-2.76-1.24-2.76-2.76v-14.13c0-1.52,1.24-2.76,2.76-2.76Z",
    transform: "translate(4100.09 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 2031.4,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4080.92 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2032.1,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4066.32 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2032.62,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4066.66 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2035.02,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4072.16 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2035.54,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4072.49 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2037.94,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4078 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2038.46,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4078.33 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2040.85,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4083.83 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2041.37,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4084.17 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2043.77,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4089.67 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2044.29,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4090 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2046.69,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4095.51 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2047.21,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4095.84 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 2050.57,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(4119.26 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2051.27,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4104.67 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2051.79,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4105.01 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2054.19,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4110.51 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2054.71,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4110.84 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2057.11,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4116.35 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2057.63,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4116.68 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2060.03,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4122.18 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2060.55,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4122.52 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2062.95,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4128.02 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2063.47,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4128.35 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2065.86,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(4133.86 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2066.39,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(4134.19 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 2613.83,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(5268.54 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 2615.63,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(5249.37 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2616.32,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5234.78 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2616.85,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5235.11 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2619.24,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5240.61 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2619.76,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5240.95 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2622.16,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5246.45 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2622.68,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5246.78 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2625.08,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5252.29 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2625.6,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5252.62 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2628,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5258.12 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2628.52,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5258.46 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 2630.92,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5263.96 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 2631.44,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5264.29 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 2634.8,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(5287.72 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2635.5,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5273.13 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2636.02,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5273.46 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2638.42,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5278.96 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2638.94,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5279.3 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2641.34,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5284.8 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2641.86,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5285.13 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2644.25,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5290.64 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2644.78,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5290.97 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2647.17,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5296.47 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2647.69,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5296.81 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2650.09,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(5302.31 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2650.61,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(5302.64 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 3198.06,
    y: 474.55,
    width: 40.89,
    height: 19.65,
    rx: 2.76,
    ry: 2.76,
    transform: "translate(6437 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 3199.85,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(6417.82 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3200.55,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6403.23 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 3201.07,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6403.56 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3203.47,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6409.07 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 3203.99,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6409.4 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3206.39,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6414.9 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 3206.91,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6415.24 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3209.31,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6420.74 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 3209.83,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6421.07 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3212.22,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6426.58 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 3212.75,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6426.91 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 3215.14,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6432.41 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 3215.66,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6432.75 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 3219.03,
    y: 476.63,
    width: 18.12,
    height: 15.49,
    rx: 2.74,
    ry: 2.74,
    transform: "translate(6456.17 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3219.73,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6441.58 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3220.25,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6441.91 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3222.64,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6447.42 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3223.17,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6447.75 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3225.56,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6453.25 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3226.08,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6453.59 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3228.48,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6459.09 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3229,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6459.42 960.27) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3231.4,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6464.92 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3231.92,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6465.26 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3234.32,
    y: 478.11,
    width: 2.13,
    height: 12.54,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(6470.76 968.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3234.84,
    y: 478.36,
    width: 1.42,
    height: 3.56,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(6471.09 960.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 209.05,
    y: 415.69,
    width: 39.07,
    height: 16.37,
    rx: 8.19,
    ry: 8.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 213.75,
    y: 420.31,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M214.65,427.45h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M241.03,420.31h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 215.17,
    y: 421.31,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 74.39,
    y: 499.36,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M77.85,500.3h13.79c1.29,0,2.33,1.04,2.33,2.33v6.34c0,1.29-1.04,2.33-2.33,2.33h-13.79c-1.29,0-2.33-1.04-2.33-2.33v-6.34c0-1.29,1.04-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 91.09,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.28,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 88.12,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.31,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 85.15,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.34,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 82.18,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.37,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 79.21,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.4,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 76.23,
    y: 501.35,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.43,
    y: 501.52,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M16.73,389.67c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M7.69,359.52c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.2-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M128.21,249.6h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.26-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-242",
    cx: 15.79,
    cy: 306.76,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M16.55,264.22h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M8.21,272.49h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M381.8,531.84c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.1c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M357.3,245.9H117.75c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h100.96c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M386.51,529.59c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.9,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M28.95,470.04h0c-.25,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M42.47,482.36c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M39.77,430.68c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M92.59,414.97c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM123.71,257.59c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M325.46,370.91h-41.37c-6.78,0-12.29-5.51-12.29-12.29v-91.13c0-6.78,5.51-12.29,12.29-12.29h41.37c6.78,0,12.29,5.51,12.29,12.29v91.13c0,6.78-5.51,12.29-12.29,12.29ZM284.09,257.59c-5.45,0-9.89,4.44-9.89,9.89v91.13c0,5.45,4.44,9.89,9.89,9.89h41.37c5.45,0,9.89-4.44,9.89-9.89v-91.13c0-5.45-4.44-9.89-9.89-9.89h-41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M34.83,436.86h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5AxTandemSingleSingle);
export default __webpack_public_path__ + "static/media/5-Ax Tandem-Single-Single.ef9f684e9213575b8ec4e5461fb5641a.svg";
export { ForwardRef as ReactComponent };